import { INombreConfiguracion } from 'src/app/shared/models/NombreConfiguracion';
import IArea from 'src/app/shared/models/Area';
import IConfiguracionUnidades from 'src/app/shared/models/ConfiguracionUnidades';
import { IUsuarios } from './../../shared/models/usuarios';
import { ConfirmationService, ConfirmEventType, MessageService, MenuItem } from 'primeng/api';
import { AfterViewInit, Component,ElementRef, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { HttpService } from 'src/app/shared/services/http.service';
import ClientesProspecto from 'src/app/shared/models/ClientesProspecto';
import { Estatus } from 'src/app/shared/models/Estatus';
import { FormArray, FormControl, FormControlName, FormGroup, Validators } from '@angular/forms';
import { IResultadoGeneral } from 'src/app/shared/models/IResultadoGeneral';
import { AuthService } from 'src/app/shared/services/auth.service';
import { clienteprospecto } from 'src/app/shared/services/clienteprospecto.service';
import User from 'src/app/shared/models/user';
import { tipoProyecto } from 'src/app/shared/services/tipoProyecto.service';
import { UsuariosService } from 'src/app/shared/services/usuarios.service';
import ITabuladorCostos from 'src/app/shared/models/TabuladorCostos';
import ITabuladorDiario from 'src/app/shared/models/TabuladorDiario';
import { tabuladorCostosService } from 'src/app/shared/services/tabuladorCostos.service';
import { ActivatedRoute, NavigationEnd } from '@angular/router';
import { Router } from '@angular/router'
import Estados_Ciudades from 'src/app/shared/models/Estados_Ciudades';
import { ITipoCliente } from 'src/app/shared/models/TipoCliente';
import { Chart, registerables } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { saveAs } from 'file-saver';
//import * as XLSX from 'xlsx';
import * as XLSX from 'xlsx-js-style';
import IExportar from 'src/app/shared/models/ExportarTabulador';
import { IEstatusPropuesta } from 'src/app/shared/models/EstatusPropuesta';
import { from, Observable, switchMap } from 'rxjs';
import ContactoEmpresa from 'src/app/shared/models/ContactoEmpresa';
import { IIimporteCasetaCiudad } from 'src/app/shared/models/ImporteCasetaCiudad';
import { FormBuilder } from '@angular/forms';
import { PrimeNGConfig } from 'primeng/api';
import { GlobalMapsService } from 'src/app/shared/services/globalmaps.service';
import ICiudades from 'src/app/shared/models/Ciudades';
import { concatMap, catchError, finalize, toArray } from 'rxjs/operators';

interface Column {
  field:string;
  header: string;
}
Chart.register(...registerables, ChartDataLabels);
@Component({
  selector: 'app-tabulador-costos',
  templateUrl: './tabulador-costos.component.html',
  styleUrls: ['./tabulador-costos.component.scss']
})
export class TabuladorCostosComponent implements OnInit {
  tabuladorDiarioData: ITabuladorDiario[] = [];
  opcionesDiasFrecuencia: any[] = []; 
  dspTabuladorDiario: boolean = false; 
  tablaExportar: IExportar[] = [];
  idruta: any = null;
  num_kilometros_tabulador: number = 0;
  totalImportes: number = 0;
  opcionesModoRuta = [
    { label: 'RT', value: 1 },
    { label: 'OW', value: 2 }
  ];
  opcionesSiNo = [
    { label: 'NO', value: 0 },
    { label: 'SI', value: 1 }
  ];
  data: any
  numeroExportar:string='';
  kampo:string='';
  id_categoria: number = 0;
  seleccionExportar: any[] = [];
  datosRecibidos: any;
  TabuladorCostos: ITabuladorCostos[] = [];
  DatosClientesProspecto: ClientesProspecto[] = [];
  Obj_Cotizacion:any[]=[];
  idx_tabulador:number=0;
  valorNum:number=0;
  texto:string='Ver como Lista';
  configuracionesSeleccionadas: number[] = [];
  bntDescargarCotizacion:boolean=false;
  dspVerDetallado:boolean=false;
  tablaRespuesta: any[] = [];
  tablaVacia: any[] = [];
  dspTablaRegreso: boolean = false;
  NombreEmpresaGlobal: string = '';
  num_totalpersonas_tabulador:number=0;
  idx_global:number=0;
  IdClienteGlobal: number = 0;
  cat_clientesProspecto: ClientesProspecto[] = [];
  loading: boolean = false;
  showCargaMasiva: boolean = true;
  loadingMasiva: boolean = false;
  isSaving: boolean = false;
  cols!: Column[];
  id_corridaglobal:number=0;
  dspTabulador: boolean = false;
  cat_ConfiguracionUnidades: IConfiguracionUnidades[] = [];
  estados: Estados_Ciudades[] = [];
  previousSelectedValues: any[] = [];
  num_dias_tabulador:number=0;
  setidGlobal: number = 0;
  setnomGlobal: string = '';
  costoGlobal: number = 0;
  dspGrafica: boolean = false;
  valorSeleccionado: number = 0;
  valorEstatus:number=0;
  lstNombreConfiguracion: string[] = [];
  cat_estatuspropuesta:IEstatusPropuesta[]=[];
  texto_header:string='';
  texto_configuracion:string="";
  dspFrmCotizacion:boolean=false;
  opciones: MenuItem[] = [];
  opcTabulado:MenuItem[]=[];
  importes: { [key: number]: number } = {};
  estatusPropuesta: any[] = [{
    value: 1,
    label: 'ENVIADO',
    icon: 'pi pi-check',
    bgColor: 'green'
  },
  {
    value: 0,
    label: 'NO ENVIADO',
    icon: 'pi pi-times',
    bgColor: 'orange',
  }]
  num_diasGlobal: number = 0;
  municipioscat: any[] = [];
  MunicipiosFiltrados: any[] = [];
  centrosCostosHm: ICiudades[] = [];

  isSavingRuta: boolean = false;

  claveRutaGenerada: string = '';
  clienteExiste: boolean = false; 

  dspOfrecerRuta: boolean = false;
  clienteEnlazado: boolean = false;
  rutaGeneradaExito: boolean = false;
  claveRutaGeneradaId: number = 0;
  claveRutaGeneradaTexto: string = '';
  
  rutaForm: FormGroup = new FormGroup({
      nombreRutaManual: new FormControl('', [Validators.required]), 
      destinoRutaManual: new FormControl({value: '', disabled: true}) 
  });

  tabForm: FormGroup = new FormGroup({
      sueldo_total_chofer: new FormControl({value: 0, disabled: true}), 
      imp_sueldoaux: new FormControl({value: 0, disabled: true}), 
      imp_viaticos_chofer: new FormControl({value: 0, disabled: true}), 
      imp_viaticos_aux: new FormControl({value: 0, disabled: true}), 
      imp_hospedaje_chofer: new FormControl({value: 0, disabled: true}), 
      imp_hospedaje_aux: new FormControl({value: 0, disabled: true})    
  });

  rutaCalculada: boolean = false;

  catalogo_TipoCliente: ITipoCliente[] = [{
    id_TipoCliente: 1,
    des_TipoCliente: 'Propio'
  },
  {
    id_TipoCliente: 2,
    des_TipoCliente: 'Comision de Terceros'
  }]
  data_tabulador:any;
  isListView:boolean=false;
  TipoClienteSeleccionado: number = 0;
  importeSeleccionado: number = 0; 
  dataLoaded = false;
  options: any;
  shouldShowHospedaje: boolean = false;
  
  TablaRespuestaEditar:any[]=[];
  usuario: User = {};
  municipios: Estados_Ciudades[] = [];
  color_gris_deshabilitadas: string = '#D9D9D9';
  @ViewChild('dt1') dt!: Table;

  selectedValue: number = 0;
  selectedvaluestring: string = '';
  valor: number = 0;
  dspEditarTAbulado:boolean=false;
  TabuladorDetalleForm:FormGroup=new FormGroup({

  })
  cat_Rutas: IArea[] = [];

opcionesPerfilRuta = [
  { label: 'Industrial', value: 1, importe: 0 },
  { label: 'Metropolitana', value: 2, importe: 152.72 }
];
  CategoriasDetalle:any[]=[];

  tabuladorForm: FormGroup = new FormGroup({
    tipo_tabulado: new FormControl(1, [Validators.required]),
    configuracion_Unidad: new FormControl<IConfiguracionUnidades | null>(null, [Validators.required]),
    Area: new FormControl(null, [Validators.required]),
    kilometros: new FormControl(0, [Validators.required]),
    hrs_carga_descarga: new FormControl(0, [Validators.required]),
    hrs_traslado_carga: new FormControl(0, [Validators.required]),
    hrs_espera_salida: new FormControl(0, [Validators.required]),
    hrs_retorno_base: new FormControl(0, [Validators.required]),
    num_choferes: new FormControl(0, [Validators.required]),
    num_auxiliares: new FormControl(0, [Validators.required]),
    porcentaje_UTD: new FormControl(0, [Validators.required]),
    tipo_cliente: new FormControl('', [Validators.required]),
    km_Inicial: new FormControl(0, []),
    km_Final: new FormControl(0, []),
    sueldo_Driver: new FormControl(0, []),
    sueldo_Auxiliar: new FormControl(0, []),
    rH_diario: new FormControl(0, []),
    mto_Diario: new FormControl(0, []),
    monitoreo_Diario: new FormControl(0, []),
    operaciones: new FormControl(0, []),
    seguridadPatrimonial: new FormControl(0, []),
    comercial: new FormControl(0, []),
    origen: new FormControl(0, [Validators.required]),
    destino: new FormControl(0, [Validators.required]),
    escala: new FormControl(0, []),
    imp_peajeindividual_extr: new FormControl(0, []),
    imp_porcentajecancelado_extr: new FormControl(0, []),
    imp_descargaCompleta_extr: new FormControl(0, []),
    num_Personas_extr: new FormControl(0, []),
    imp_Persona_extr: new FormControl(0, []),
    imp_Subcontrato_extr: new FormControl(0, []),
    comision_cliente: new FormControl(0, []),
    centro_costos: new FormControl(null, [Validators.required]),
    es_truck: new FormControl(0, []),
    num_stop: new FormControl(0, []),
    maniobras: new FormControl(0, []),
    id_modo_ruta: new FormControl(null, [Validators.required]),
    perfilRuta: new FormControl(null, [Validators.required]),
    hrs_pernocta: new FormControl(0, [Validators.required]),
    num_dias_frecuencia: new FormControl(0, [Validators.required]),

    TxtOrigen: new FormControl('', []),
    origenAddr: new FormControl(''),
    LatOrigen: new FormControl(null, []),
    LonOrigen: new FormControl(null, []),
    TxtDestino: new FormControl('', []),
    destinoAddr: new FormControl(''),
    LatDestino: new FormControl(null, []),
    LonDestino: new FormControl(null, []),

    google_origen_address: new FormControl('', []),
    google_origen_lat: new FormControl(null, []),
    google_origen_lng: new FormControl(null, []),
    google_origen_address_components: new FormControl(null, []),

    google_destino_address: new FormControl('', []),
    google_destino_lat: new FormControl(null, []),
    google_destino_lng: new FormControl(null, []),
    google_destino_address_components: new FormControl(null, []),

    google_escala_address: new FormControl('', []),
    google_escala_lat: new FormControl(null, []),
    google_escala_lng: new FormControl(null, []),
    google_escala_address_components: new FormControl(null, []),

    paradas: new FormArray([]),
  })
  uniqueConfigurations: string[]=[];
  importesForms: FormGroup[] = [];
  importesForm: FormGroup[] = [];
  objImporteCaseta:IIimporteCasetaCiudad[]=[];

  googleOrigenSearch: string = '';
  googleDestinoSearch: string = '';
  googleEscalaSearch: string = '';

  googleGeocodeLoading: boolean = false;
  maxParadas: number = 6;

  EditarTabuladoForm:FormGroup = new FormGroup({
    tipo_tabulado: new FormControl(1, [Validators.required]),
    configuracion_Unidad: new FormControl(0, [Validators.required]),
    Area: new FormControl(null, [Validators.required]),
    kilometros: new FormControl(1, []),
    hrs_carga_descarga: new FormControl(0, []),
    hrs_traslado_carga: new FormControl(0, []),
    hrs_espera_salida: new FormControl(0, []),
    hrs_retorno_base: new FormControl(0, []),
    num_choferes: new FormControl(0, []),
    num_auxiliares: new FormControl(0, []),
    porcentaje_UTD: new FormControl(0, []),
    tipo_cliente: new FormControl('', []),
    km_Inicial: new FormControl(0, []),
    km_Final: new FormControl(0, []),
    sueldo_Driver: new FormControl(0, []),
    sueldo_Auxiliar: new FormControl(0, []),
    rH_diario: new FormControl(0, []),
    mto_Diario: new FormControl(0, []),
    monitoreo_Diario: new FormControl(0, []),
    operaciones: new FormControl(0, []),
    seguridadPatrimonial: new FormControl(0, []),
    comercial: new FormControl(0, []),
    origen: new FormControl(0, []),
    destino: new FormControl(0, []),
    escala: new FormControl(0, []),
    imp_peajeindividual_extr: new FormControl(0, []),
    imp_porcentajecancelado_extr: new FormControl(0, []),
    imp_descargaCompleta_extr: new FormControl(0, []),
    num_Personas_extr: new FormControl(0, []),
    imp_Persona_extr: new FormControl(0, []),
    imp_Subcontrato_extr: new FormControl(0, []),
    comision_cliente: new FormControl(0, []),
    centro_costos: new FormControl(null, []),
    es_truck: new FormControl(0, []),
    num_stop: new FormControl(0, []),
    maniobras: new FormControl(0, []),
    id_modo_ruta: new FormControl(null, [Validators.required]),
    perfilRuta: new FormControl(null, [Validators.required]),
    hrs_pernocta: new FormControl(0, [Validators.required]),
    num_dias_frecuencia: new FormControl(0, [Validators.required]),
    num_dias_dec: new FormControl(0,[] ),

    TxtOrigen: new FormControl('', []),
    LatOrigen: new FormControl(null, []),
    LonOrigen: new FormControl(null, []),
    origenAddr: new FormControl(''),
    TxtDestino: new FormControl('', []),
    LatDestino: new FormControl(null, []),
    LonDestino: new FormControl(null, []),
    destinoAddr: new FormControl(''),

    google_origen_address: new FormControl('', []),
    google_origen_lat: new FormControl(null, []),
    google_origen_lng: new FormControl(null, []),
    google_origen_address_components: new FormControl(null, []),

    google_destino_address: new FormControl('', []),
    google_destino_lat: new FormControl(null, []),
    google_destino_lng: new FormControl(null, []),
    google_destino_address_components: new FormControl(null, []),

    google_escala_address: new FormControl('', []),
    google_escala_lat: new FormControl(null, []),
    google_escala_lng: new FormControl(null, []),
    google_escala_address_components: new FormControl(null, []),

    paradas: new FormArray([]),
  })

  configuracionSeleccionada:number=0;
  datoseditartabulador:any[]=[];

  CotizacionForm: FormGroup = new FormGroup({
    nom_Contacto: new FormControl('', [Validators.required]),
    num_DiasOperativos: new FormControl(0, [Validators.required]),
    fecha_emision:new FormControl('',[Validators.required]),
    id_jornadaOperacion: new FormControl(0, [Validators.required]),
    hrs_EsperaDescarga: new FormControl(0, [Validators.required]),
    hrs_Advertencia:new FormControl(0,[Validators.required]),
    num_porcentajeFleteFalso: new FormControl(0, [Validators.required]),
    num_porcentajeFleteRetorno: new FormControl(0, [Validators.required]),
    num_diasCredito: new FormControl(0, [Validators.required]),
    id_tipoEvento: new FormControl(0, [Validators.required]),
    num_VigenciaTarifaria: new FormControl(0, [Validators.required]),
    num_DiasValidez: new FormControl(0, [Validators.required]),
    num_cantidadrepartos:new FormControl(0,[Validators.required])
  })
  @ViewChild('fileUpload') fileUpload!: ElementRef<HTMLInputElement>;
  cat_nombresContacto:any[]=[{
    NombreCompletoCto:''
  }];
  
  cat_diasoperacion:any[]=[];
  cat_periodofacturacion:any[]=[];
  contactoEmpresaObj: ContactoEmpresa[] = [];
  constructor(private httpService: HttpService, private globalMapsService: GlobalMapsService,
    private ClienteProspectoService: clienteprospecto,private fb: FormBuilder, private confirmationService: ConfirmationService, private message: MessageService, private auth: AuthService,
    private tipoproyectoservice: tipoProyecto, private tabuladorService: tabuladorCostosService, private primengConfig: PrimeNGConfig,private route: ActivatedRoute, private router: Router) {
    this.cargarInformacionUsuario();
    const navigation = this.router.getCurrentNavigation();
    const state = navigation?.extras.state;
    this.opcTabulado = [
      {
        label: 'Ver Información',
        icon: 'pi pi-info-circle',
        command: () => {
          this.verTabuladorDiario(this.data_tabulador.idx);
        }
      },
      {
        label: 'Generar Cotización',
        icon: 'pi pi-briefcase',
        command: () => {
          this.VerFrmCotizacion(this.data_tabulador);
        }
      },
      {
        label: 'Editar Tabulado',
        icon: 'pi pi-file-edit',
        command: () => {
          this.EditarTabulado(this.data_tabulador);
        }
      },
      {
        separator: true
      },
      {
        label: 'Ofrecer la Ruta',
        icon: 'pi pi-directions',
        command: () => {
          if (this.data_tabulador.clv_enviado === 1) {
            this.validarYAbrirOfrecerRuta(this.data_tabulador);
          } else {
            this.message.add({ 
              key: 'msj', 
              severity: 'warn', 
              summary: 'Ruta no enviada', 
              detail: 'Debe marcar la cotización como ENVIADA antes de ofrecer la ruta.' 
            });
          }
        }
      }
    ];

    this.opciones = [
      {
        id: '1',
        label: 'Generar Tabulado',
        icon: 'pi pi-file',
        command: () => {
          this.Tabular();
        }
      },
      {
        id: '2',
        label: 'Carga Masiva Excel',
        icon: 'pi pi-file-excel',
        command: () => {
          this.fileUpload.nativeElement.click();
        }
      }
    ];

    if (state && state['datos']) {
      const datosRecibidos = state['datos'];
      this.DatosClientesProspecto = datosRecibidos;
      this.NombreEmpresaGlobal = datosRecibidos.nom_empresa;
      this.IdClienteGlobal = datosRecibidos.id_cte_prospecto;
      localStorage.setItem('DatosClientesProspecto', JSON.stringify(datosRecibidos));
    } else {
      const savedDatos = localStorage.getItem('DatosClientesProspecto');
      if (savedDatos) {
        const datosRecibidos = JSON.parse(savedDatos);
        this.DatosClientesProspecto = datosRecibidos;
        this.NombreEmpresaGlobal = datosRecibidos.nom_empresa;
        this.IdClienteGlobal = datosRecibidos.id_cte_prospecto;
      }
    }
  }

  ngOnInit(): void {
    this.setProspecto();
    this.ObtenerTablaPrincipal();
    this.ObtenerConfiguracionUnidades();
    this.ObtenerTiposRuta();
    this.getListadoEstados();
    this.ObtenerMunicipios();
    this.ObtenerCiudadesHm();
    this.ObtenerPropuestaEstatus();
    this.ObtenerOracionesJornada();
    this.ObtenerPeriodoFacturacion();
    this.generarDiasDelMes(); 
    this.primengConfig.setTranslation({
      startsWith: 'Empieza con',
      contains: 'Contiene',
      notContains: 'No contiene',
      endsWith: 'Termina con',
      equals: 'Igual a',
      notEquals: 'Diferente de',
      dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
      dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
      dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
      monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
      monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
      today: 'Hoy',
      clear: 'Limpiar',
      lt: 'Menor que',
      lte: 'Menor o igual que',
      gt: 'Mayor que',
      gte: 'Mayor o igual que',
      is: 'Es',
      isNot: 'No es',
      before: 'Antes',
      after: 'Después',
      apply: 'Aplicar',
      matchAll: 'Coincidir con todo',
      matchAny: 'Coincidir con cualquiera',
      addRule: 'Agregar regla',
      removeRule: 'Eliminar regla',
      accept: 'Sí',
      reject: 'No',
    });

    this.ensureParadasIniciales();
    this.tabuladorForm.get('tipo_tabulado')?.setValue(1, { emitEvent: false });
    this.onTipoTabuladoChange({ value: 1 }, this.tabuladorForm);
  }

  onTipoTabuladoChange(event: any, form: FormGroup) {
    const selectedValue = event.value;
    this.rutaCalculada = false;
    
    const allControls = [
      'configuracion_Unidad', 'Area', 'kilometros', 'hrs_carga_descarga',
      'hrs_traslado_carga', 'hrs_espera_salida', 'hrs_retorno_base', 'num_choferes',
      'num_auxiliares', 'porcentaje_UTD', 'tipo_cliente', 'origen', 'destino',
      'escala', 'imp_peajeindividual_extr', 'imp_porcentajecancelado_extr',
      'imp_descargaCompleta_extr', 'num_Personas_extr', 'imp_Persona_extr',
      'imp_Subcontrato_extr', 'comision_cliente', 'centro_costos', 'es_truck',
      'num_stop', 'maniobras', 'id_modo_ruta', 'perfilRuta', 'hrs_pernocta'
    ];

    allControls.forEach(controlName => form.get(controlName)?.disable());

if (selectedValue === 1) { // RUTA CON GLOBAL MAPS
  form.get('configuracion_Unidad')?.enable();
  form.get('Area')?.enable();
  form.get('origen')?.enable();
  form.get('destino')?.enable();
  form.get('escala')?.enable(); // <- opcional, pero habilitada
  form.get('centro_costos')?.enable();
  form.get('es_truck')?.enable();
  form.get('maniobras')?.enable();
  form.get('num_stop')?.enable();
  form.get('kilometros')?.enable();
  form.get('Area')?.setValue(2, { emitEvent: false });
    } else if (selectedValue === 2) { // RUTA SIN GLOBAL MAPS
      allControls.forEach(controlName => {
        if (controlName !== 'hrs_traslado_carga' && controlName !== 'hrs_retorno_base') {
            form.get(controlName)?.enable();
            form.get('Area')?.setValue(2, { emitEvent: false });
        }
      });
    }
  }
  
  private getActiveForm(): FormGroup {
    return this.dspEditarTAbulado ? this.EditarTabuladoForm : this.tabuladorForm;
  }

  private getParadasFormArray(form?: FormGroup): FormArray {
    const targetForm = form ?? this.getActiveForm();
    return targetForm.get('paradas') as FormArray;
  }

  get comision(): FormControl | null {
    const form = this.getActiveForm();
    return (form.get('comision_cliente') as FormControl) ?? null;
  }
  calcularRuta() {
    const form = this.getActiveForm();
    const origenId = form.get('LatOrigen')?.value;
    const destinoId = form.get('LatDestino')?.value;
    if (!origenId || !destinoId) {
        this.message.add({ severity: 'warn', summary: 'Datos incompletos', detail: 'Debe seleccionar Origen, Destino y al menos una Configuración de Unidad.' });
        return;
    }

    this.loading = true;

    const origenObj = form.get('TxtOrigen')?.value;
    const destinoObj = form.get('TxtDestino')?.value;

    if (!origenObj || !destinoObj) {
        this.message.add({ severity: 'error', summary: 'Error de Datos', detail: 'No se encontraron los datos de origen o destino.' });
        this.loading = false;
        return;
    }

    const paradasValores = this.obtenerParadasValores(form);
    const txtOrigen = form.get('TxtOrigen')?.value || origenObj || '';
    const latOrigen = form.get('LatOrigen')?.value ?? 0;
    const lonOrigen = form.get('LonOrigen')?.value ?? 0;
    const txtDestino = form.get('TxtDestino')?.value || destinoObj || '';
    const latDestino = form.get('LatDestino')?.value ?? 0;
    const lonDestino = form.get('LonDestino')?.value ?? 0;

    const intermediates = paradasValores
      .filter(parada => parada.lat !== null && parada.lng !== null && !(parada.lat === 0 && parada.lng === 0))
      .map(parada => ({
        location: {
          latLng: {
            latitude: parada.lat,
            longitude: parada.lng
          }
        }
      }));

    const payload = {
      origin: {
        location: {
          latLng: {
            latitude: latOrigen,
            longitude: lonOrigen
          }
        }
      },
      destination: {
        location: {
          latLng: {
            latitude: latDestino,
            longitude: lonDestino
          }
        }
      },
      intermediates,
      travelMode: 'DRIVE',
      routingPreference: 'TRAFFIC_AWARE',
      computeAlternativeRoutes: false,
      routeModifiers: {
        avoidTolls: false,
        avoidHighways: false,
        avoidFerries: false
      },
      languageCode: 'es-MX',
      units: 'METRIC'
    };

    this.globalMapsService.calcularRuta(payload).subscribe({
      next: (response: any) => {
        const distanceMetersTotal = response?.distanceMetersTotal ?? 0;
        const distanciaKm = Math.ceil(distanceMetersTotal / 1000);
        form.get('kilometros')?.setValue(distanciaKm==0?1:distanciaKm);

        this.message.add({ severity: 'success', summary: 'Ruta Calculada', detail: 'Cálculo de kilometros exitoso.' });

        if (!this.rutaCalculada) {
          this.rutaCalculada = true;
          form.get('origen')?.disable();
          form.get('destino')?.disable();

          const controlsToEnable = [
            'Area', 'hrs_carga_descarga', 'hrs_espera_salida',
            'hrs_pernocta', 'num_choferes', 'num_auxiliares', 'porcentaje_UTD',
            'tipo_cliente', 'comision_cliente', 'centro_costos', 'es_truck',
            'num_stop', 'maniobras', 'id_modo_ruta', 'perfilRuta','hrs_traslado_carga',
            'hrs_retorno_base'
          ];
          controlsToEnable.forEach(controlName => form.get(controlName)?.enable());

          form.get('kilometros')?.enable();
        }
      },
      error: (err) => {
        this.loading = false;
        console.error('Error en Global Maps:', err);
        this.message.add({ severity: 'error', summary: 'Error de C lculo', detail: 'No se pudo calcular la ruta.' });
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  checkHospedajeColumn() {
    this.shouldShowHospedaje = this.TabuladorCostos.some(item => item.num_dias > 0);
  }

guardarInformacionEditarTabulador() {
    if (this.EditarTabuladoForm.get('tipo_tabulado')?.value === 1 && !this.rutaCalculada) {
        this.message.add({ severity: 'error', summary: 'Cálculo Requerido', detail: 'Debe presionar el botón "Calcular Kilometros" antes de cotizar.' });
        return; 
    }
    
    this.confirmationService.confirm({
      message: 'Esta seguro que desea cotizar la información ?',
      header: 'Confirmación de Cotizar',
      icon: 'pi pi-info-circle',
      accept: () => {
        const paradasValores = this.obtenerParadasValores(this.EditarTabuladoForm);
        
        let data_enviar = {
          idx: this.idx_global,
          id_tipo_tabulado: this.EditarTabuladoForm.get('tipo_tabulado')?.value,
          id_config_unidad: this.objImporteCaseta[0].id_configuracion,
          imp_peaje: this.objImporteCaseta[0].importeCasetaConfiguracion,
          id_tiporuta: this.EditarTabuladoForm.get('Area')?.value,
          des_origen: this.getOrigenTexto(this.EditarTabuladoForm),
          des_destino: this.getDestinoTexto(this.EditarTabuladoForm),
          des_escala: this.getEscalaTexto(this.EditarTabuladoForm),
          LatEscala: this.getEscalaCoordString(paradasValores, 'lat'),
          LonEscala: this.getEscalaCoordString(paradasValores, 'lng'),
          LatOrigen: this.toStr(this.EditarTabuladoForm.get('LatOrigen')?.value ?? ''),
          LonOrigen: this.toStr(this.EditarTabuladoForm.get('LonOrigen')?.value ?? ''),
          LatDestino: this.toStr(this.EditarTabuladoForm.get('LatDestino')?.value ?? ''),
          LonDestino: this.toStr(this.EditarTabuladoForm.get('LonDestino')?.value ?? ''),
          num_kilometros: this.EditarTabuladoForm.get('kilometros')?.value,
          horas_cargaydescarga: this.EditarTabuladoForm.get('hrs_carga_descarga')?.value,
          num_choferes: this.EditarTabuladoForm.get('num_choferes')?.value,
          num_auxiliares: this.EditarTabuladoForm.get('num_auxiliares')?.value,
          num_porcentajeutd: this.objImporteCaseta.length > 0 ? this.objImporteCaseta[0].porcentajeUtilidadConfiguracion : this.EditarTabuladoForm.get('porcentaje_UTD')?.value,
          id_tipo_cliente: this.EditarTabuladoForm.get('tipo_cliente')?.value,
          imp_terceros: this.TipoClienteSeleccionado == 2 ? this.EditarTabuladoForm.get('comision_cliente')?.value : 0,
          imp_peajeindividual_extr: this.EditarTabuladoForm.get('imp_peajeindividual_extr')?.value ?? 0,
          imp_porcentajecancelado_extr: this.EditarTabuladoForm.get('imp_porcentajecancelado_extr')?.value ?? 0,
          imp_descargaCompleta_extr: this.EditarTabuladoForm.get('imp_descargaCompleta_extr')?.value ?? 0,
          num_Personas_extr: this.EditarTabuladoForm.get('num_Personas_extr')?.value ?? 0,
          imp_Persona_extr: this.EditarTabuladoForm.get('imp_Persona_extr')?.value ?? 0,
          imp_Subcontrato_extr: this.EditarTabuladoForm.get('imp_Subcontrato_extr')?.value ?? 0,
          id_corrida: this.id_corridaglobal,
          horas_esperasalida: this.EditarTabuladoForm.get('hrs_espera_salida')?.value,
          id_modo_ruta: this.EditarTabuladoForm.get('id_modo_ruta')?.value,
          id_ciudad: this.EditarTabuladoForm.get('centro_costos')?.value,
          clv_truck: 0,
          num_stop: this.EditarTabuladoForm.get('num_stop')?.value,
          clv_maniobras: this.EditarTabuladoForm.get('maniobras')?.value,
          id_perfil_ruta: this.EditarTabuladoForm.get('perfilRuta')?.value,
          id_cte_prospecto: this.IdClienteGlobal,
          num_horas_pernocta: this.EditarTabuladoForm.get('hrs_pernocta')?.value,
          num_dias_frecuencia: this.EditarTabuladoForm.get('num_dias_frecuencia')?.value,
        };

        this.tabuladorService.GetTabuladorEdit(data_enviar).subscribe((resp) => {
          const idCiudadSel = this.EditarTabuladoForm.get('centro_costos')?.value;
          const ciudadObj = (this.centrosCostosHm || []).find((c: any) => c.id == idCiudadSel);
          
          this.TablaRespuestaEditar = resp.map((item: any) => {
              return {
                ...item,
                nom_ciudad: ciudadObj ? ciudadObj.municipio : 'N/A'
              };
          });

          this.uniqueConfigurations = this.getUniqueConfigurations(this.TablaRespuestaEditar);
          
          this.cols = [
            { field: 'id_corrida', header: 'No. Tabulado' },
            { field: 'configuracion', header: 'Conf. Unidad' },
            { field: 'origen', header: 'Origen' },
            { field: 'destino', header: 'Destino' },
            { field: 'escala', header: 'Escala' },
            { field: 'num_dias', header: 'Numero de Dias' },
            { field: 'costo', header: 'Costo' },
            { field: 'num_porcentajeutd', header: 'Porcentaje UTD' },
            { field: 'imp_preciodeventa', header: 'Precio de Venta' },
            { field: 'imp_utilidad', header: 'Utilidad' },
            { field: 'imp_utilidadmensual', header: 'Utilidad Mensual' },
            { field: 'imp_sueldochofer', header: 'Sueldo Chofer' },
            { field: 'imp_sueldoaux', header: 'Sueldo Auxiliar' },
            { field: 'imp_combustible', header: 'Gasto Combustible' },
            { field: 'imp_comisioncombustible', header: 'Gasto Comision Combustible' },
            { field: 'imp_cel_gps', header: 'Gasto Celular GPS' },
            { field: 'imp_imss', header: 'IMSS' },
            { field: 'imp_hospedaje', header: 'Gasto Hospedaje' },
            { field: 'imp_viaticos', header: 'Gasto Viaticos' },
          ];

          setTimeout(() => {
            this.EditarTabuladoForm.reset();
            this.EditarTabuladoForm.patchValue({
              imp_porcentajecancelado_extr: 40,
              porcentaje_UTD: 35,
              hrs_carga_descarga: 1,
              hrs_traslado_carga: 1,
              hrs_espera_salida: 1,
              hrs_retorno_base: 1,
              hrs_pernocta: 1
            });
            this.configuracionesSeleccionadas = [];
            this.dspTablaRegreso = true;
            this.TipoClienteSeleccionado = 0;
            this.rutaCalculada = false;
          }, 400);
        });
      },
      reject: (type: any) => {
        this.message.add({ key: 'msj', severity: 'warn', summary: 'Cancelado', detail: 'Operacion cancelada por usuario' });
      }
    });
  }
  
  get totalImporteActivo(): number {
    return this.CategoriasDetalle
      .filter(item => item.clv_activo === 1) 
      .reduce((acc, item) => acc + item.importe, 0); 
  }

  get ImportePorDia():number{
    if(this.num_totalpersonas_tabulador>0){
      return this.CategoriasDetalle
      .filter(item => item.clv_activo === 1) 
      .reduce((acc, item) => acc + item.importe * this.num_dias_tabulador * this.num_totalpersonas_tabulador, 0);
    }else{
      return this.CategoriasDetalle
      .filter(item => item.clv_activo === 1) 
      .reduce((acc, item) => acc + item.importe * this.num_dias_tabulador, 0);
    }
    
  }
  get NumPersonal():number {
    return this.CategoriasDetalle.length > 0 ? this.CategoriasDetalle[0].num_total_personas : 0;
  }

  ObtenerTabuladorDetalle(data: any, id_categoria: number) {

    this.id_categoria = id_categoria;

    if (id_categoria == 1) {
      this.texto_header = "Detalle Vehiculos";
    } else if (id_categoria == 2) {
      this.texto_header = "Detalle Recursos Humanos";
    } else if (id_categoria == 3) {
      this.texto_header = "Detalle Propuesta de Valor";
    } else if (id_categoria == 4) {
      this.texto_header = "Detalle Permisos de Circulacion";
    } else if (id_categoria == 5) {
      this.texto_header = "Detalle Herramientas de Seguridad y Monitoreo";
    } else if (id_categoria == 6) {
      this.texto_header = "Detalle Combustibles y Casetas";
    } else if (id_categoria == 7) {
      this.texto_header = "Detalle Servicios Preventivos";
    } else if (id_categoria == 8) {
      this.texto_header = "Detalle Servicios Correctivos";
    }

   
    this.num_dias_tabulador = data.num_dias;
    this.texto_configuracion = data.config_unidad;
    this.num_kilometros_tabulador = data.num_kilometros;
    this.totalImportes = data.total_importe;


    let data_enviar = {
      idx: data.idx,
      id_categoria: id_categoria
    };

    this.tabuladorService.GetCategoriasDetalle(data_enviar).subscribe((resp) => {
      this.CategoriasDetalle = resp;
      this.num_totalpersonas_tabulador = this.CategoriasDetalle.length > 0 ? this.CategoriasDetalle[0].num_total_personas : 0;
      this.totalImportes = this.CategoriasDetalle.length > 0 ? this.CategoriasDetalle[0].total_importe : 0;
      setTimeout(() => {
        this.dspVerDetallado = true;
      }, 150);
    });
  }

  GuardarEditarTabulado(data:any){
    if(data.imp_sueldochofer == 0)
      {
        this.confirmationService.confirm({
          message: 'No es posible almacenar este Costeo,' 
                  +' ya que no existe información en la Base de Cobros para la ciudad,'
                  +' el rango de kilómetros y la configuración de la unidad. Favor de revisar con el Administrador.',
          header: 'Advertencia',
          icon: 'pi pi-times-circle',
        });
      }
      else {
        let configu = this.cat_ConfiguracionUnidades.find(obj => obj.nombre === data.configuracion)
        let configvalor: number = 0;
        if (configu) {
          if (configu.clave_configuracionUnidad) {
            configvalor = configu.clave_configuracionUnidad;
          }
        }
    
        let estado = this.municipioscat.find(obj => obj.municipio === data.origen);
        let id_estado: number = 0;
        if (estado) {
          if (estado.id) {
            id_estado = estado.id;
          } 
        }
        let muni = this.municipioscat.find(obj => obj.municipio === data.destino);
        let id_muni: number = 0;
        if (muni) {
          if (muni.id) {
            id_muni = muni.id;
          }
        }
        let esc = this.municipioscat.find(obj => obj.municipio === data.escala);
        let id_esc: number = 0;
        if (esc) {
          if (esc.id) {
            id_esc = esc.id;
          }
        }
        this.confirmationService.confirm({
          message: 'Estas Seguro que Deseas Guardar este Tabulado?',
          header: 'Confirmar',
          icon: 'pi pi-check-square',
          accept: () => {
            const paradasValores = this.obtenerParadasValores();
            let data_enviar = {
              id_corrida: data.id_corrida,
              id_cte_prospecto: this.IdClienteGlobal,
              id_config_unidad: data.id_config_unidad ?? configvalor,
              id_origen: data.id_origen ?? id_estado,
              id_destino: data.id_destino ?? id_muni,
              id_escala: data.id_escala ?? id_esc,

              des_origen_in: data.des_origen_in || data.origen || data.des_origen || '',
              des_destino_in: data.des_destino_in || data.destino || data.des_destino || '',
              des_escala_in: data.des_escala_in || data.escala || data.des_escala || '',
              
              latOrigen_in: this.toStr(data.latOrigen_in || data.LatOrigen_in || data.LatOrigen || ''),
              lonOrigen_in: this.toStr(data.lonOrigen_in || data.LonOrigen_in || data.LonOrigen || ''),
              latDestino_in: this.toStr(data.latDestino_in || data.LatDestino_in || data.LatDestino || ''),
              lonDestino_in: this.toStr(data.lonDestino_in || data.LonDestino_in || data.LonDestino || ''),
              latEscala_in: this.toStr(data.latEscala_in || data.LatEscala_in || data.LatEscala || ''),
              lonEscala_in: this.toStr(data.lonEscala_in || data.LonEscala_in || data.LonEscala || ''),
              
              id_ciudad_in: data.id_ciudad_in ?? data.id_ciudad ?? 0,
              num_stop_in: data.num_stop_in ?? data.num_stop ?? 0,
              clv_maniobras_in: data.clv_maniobras_in ?? data.clv_maniobras ?? 0,
              clv_truck_in: data.clv_truck_in ?? data.clv_truck ?? 0,
              
              imp_stop: data.imp_stop ?? 0,
              imp_maniobras: data.imp_maniobras ?? 0,
              imp_costo_kilometros: data.imp_costo_kilometros ?? 0,
              sueldo_total_chofer: data.sueldo_total_chofer ?? 0,


              costo: data.costo,
              imp_preciodeventa: data.imp_preciodeventa,
              imp_utilidad: data.imp_utilidad,
              imp_utilidadmensual: data.imp_utilidadmensual,
              imp_sueldochofer: data.imp_sueldochofer,
              imp_sueldoaux: data.imp_sueldoaux,
              imp_combustible: data.imp_combustible,
              imp_comisioncombustible: data.imp_comisioncombustible,
              imp_cel_gps: data.imp_cel_gps,
              imp_imss: data.imp_imss,
              imp_hospedaje: data.imp_hospedaje,
              imp_viaticos: data.imp_viaticos,
              cod_usuario: this.usuario.cod,
              num_dias: data.num_dias,
              num_dias_dec: data.num_dias_dec, //SE AGREGA NUEVO CAMPO num_dias_dec
              id_tiporuta: data.id_tiporuta,
              num_kilometros: data.num_kilometros,
              imp_peaje: data.imp_peaje,
              horas_cargaydescarga: data.horas_cargaydescarga,
              num_choferes: data.num_choferes,
              num_auxiliares: data.num_auxiliares,
              num_porcentajeutd: data.num_porcentajeutd,
              id_tipo_cliente: data.id_tipo_cliente,
              imp_terceros: data.imp_terceros,
              imp_peajeindividual_extr: data.imp_peajeindividual_extr,
              imp_porcentajecancelado_extr: data.imp_porcentajecancelado_extr,
              imp_descargaCompleta_extr: data.imp_descargaCompleta_extr,
              num_Personas_extr: data.num_Personas_extr,
              imp_Persona_extr: data.imp_Persona_extr,
              imp_Subcontrato_extr: data.imp_Subcontrato_extr,
              imp_comisionvendedor: data.imp_comisionvendedor,
              imp_comision_tercero: data.imp_comision_tercero,
              imp_mantenimiento: data.imp_mantenimiento,
              imp_operaciones: data.imp_operaciones,
              imp_seguridadpatrimonial: data.imp_seguridadpatrimonial,
              imp_depreciacion: data.imp_depreciacion,
              imp_urea: data.imp_urea,
              horas_esperasalida: data.horas_esperasalida,
              imp_propuestavalor: data.imp_propuestavalor,
              imp_permisocirculacion: data.imp_permisocirculacion,
              imp_combustible_casetas: data.imp_combustible_casetas,
              imp_serviciocorrectivo: data.imp_serviciocorrectivo,
              costo_urea_sin_iva_peaje: data.costo_urea_sin_iva_peaje,
              num_dias_ruta: data.num_dias_ruta,
              imp_utilidad_con_urea_sin_iva_peaje: data.imp_utilidad_con_urea_sin_iva_peaje,
              num_porcentaje_margen: data.num_porcentaje_margen,
              imp_llantas: data.imp_llantas,
              id_modo_ruta: data.id_modo_ruta,
              id_perfil_ruta: data.id_perfil_ruta,
              imp_perfil_ruta: data.imp_perfil_ruta,
              hrs_descanso: data.hrs_descanso,
              id_tipo_tabulado: data.id_tipo_tabulado,
              num_horas_pernocta: data.num_horas_pernocta,
              num_horas_carga_combustible: data.num_horas_carga_combustible,
              imp_pdv_comision_terceros: data.imp_pdv_comision_terceros,
              num_dias_frecuencia: data.num_dias_frecuencia,
              imp_precio_de_frecuencia: data.imp_precio_de_frecuencia,
              idx:this.idx_global,
              horas_entreservicio: data.horas_entreservicio
            }
            this.tabuladorService.UpdateTabulador(data_enviar).subscribe((resp) => {
              var respuesta = resp;
              setTimeout(() => {
                this.cargarDatosTabla(data);
                this.ObtenerTablaPrincipal();
                this.cancelarVentanaEditarModal();
                this.message.add({ severity: 'success', summary: 'Tabulado Guardado Exitosamente', detail: 'Se ha Guardado' });
              }, 200);
            })
          },
          reject: (type: any) => {
            switch (type) {
              case ConfirmEventType.REJECT:
                this.message.add({ key: 'msj', severity: 'warn', summary: 'Cancelado', detail: 'Operacion cancelada por usuario' });
                break;
              case ConfirmEventType.CANCEL:
                this.message.add({ key: 'msj', severity: 'warn', summary: 'Cancelado', detail: 'Operacion cancelada por usuario' });
                break;
            }
          }
        });
     }
  }
EditarTabulado(data: any) {

  // 1. Validar si la ruta ya fue enviada o está en revisión
  if (data.clv_enviado > 0) {
    this.message.add({
      key: 'msj',
      severity: 'warn',
      summary: 'Acción no permitida',
      detail: 'No se puede editar un tabulado que ya ha sido enviado o que está pendiente de autorización por gerencia.'
    });
    return; // Detenemos la ejecución aquí para que no se abra el diálogo
  }
  this.loading = true;
  this.idx_global = data.idx;
  this.dspTablaRegreso = false; 

  this.tabuladorService.getEditTabulador(data.idx).subscribe((resp) => {
    this.datoseditartabulador = resp;
    setTimeout(() => {
      //Original al Editar castear datos
      const data_editar_tabulador = resp[0];
      const modoOW = data_editar_tabulador.id_modo_ruta === 2;
      const unidadEspecial = data_editar_tabulador.clv_truck === 1;
      const divisorGeneral = modoOW ? 1 : 2;
      const divisorCasetas = modoOW && unidadEspecial ? 1 : 2;
      const peaje = Number(data_editar_tabulador.imp_peaje) || 0;
      const horasCarga = Number(data_editar_tabulador.horas_cargaydescarga) || 0;
      const horasDescarga = Number(data_editar_tabulador.horas_esperasalida) || 0;
      const kms = Number(data_editar_tabulador.num_kilometros) || 0;
      data_editar_tabulador.imp_peaje= Number(((peaje * 1.16) / divisorCasetas).toFixed(0));
      data_editar_tabulador.horas_cargaydescarga= horasCarga / divisorGeneral;
      data_editar_tabulador.horas_esperasalida= horasDescarga / divisorGeneral;
      data_editar_tabulador.num_kilometros= kms/divisorGeneral;
      this.datoseditartabulador[0].imp_peaje=data_editar_tabulador.imp_peaje;
      this.datoseditartabulador[0].num_kilometros=data_editar_tabulador.num_kilometros;
      this.datoseditartabulador[0].horas_cargaydescarga=data_editar_tabulador.horas_cargaydescarga;
      this.datoseditartabulador[0].horas_esperasalida=data_editar_tabulador.horas_esperasalida;
      //Fin Editar castear datos
      this.configuracionSeleccionada = this.datoseditartabulador[0].id_config_unidad;
      this.idruta = this.datoseditartabulador[0].id_tiporuta;
      this.id_corridaglobal = this.datoseditartabulador[0].id_corrida;

      this.EditarTabuladoForm.controls['configuracion_Unidad'].setValue(this.datoseditartabulador[0].id_config_unidad);
      this.Configi();

      this.EditarTabuladoForm.controls['Area'].setValue(this.datoseditartabulador[0].id_tiporuta);
      this.EditarTabuladoForm.controls['origen'].setValue(this.datoseditartabulador[0].id_origen);
      this.EditarTabuladoForm.controls['destino'].setValue(this.datoseditartabulador[0].id_destino);
      this.EditarTabuladoForm.controls['escala'].setValue(this.datoseditartabulador[0].id_escala);
      const origenTexto = (this.datoseditartabulador[0].des_origen || '').toString().trim()
        || this.getMunicipioNombreById(this.datoseditartabulador[0].id_origen);
      const destinoTexto = (this.datoseditartabulador[0].des_destino || '').toString().trim()
        || this.getMunicipioNombreById(this.datoseditartabulador[0].id_destino);
      const escalaTexto = (this.datoseditartabulador[0].des_escala || '').toString().trim()
        || this.getMunicipioNombreById(this.datoseditartabulador[0].id_escala);

      this.googleOrigenSearch = origenTexto;
      this.googleDestinoSearch = destinoTexto;

      this.EditarTabuladoForm.patchValue({
        TxtOrigen: origenTexto,
        TxtDestino: destinoTexto
      });

      const escalaPartes = (escalaTexto || '')
        .split('|')
        .map((item: string) => item.trim())
        .filter((item: string) => item.length > 0);
      const latEscalaPartes = (this.datoseditartabulador[0].latEscala || '')
        .toString()
        .split('|')
        .map((item: string) => item.trim());
      const lonEscalaPartes = (this.datoseditartabulador[0].lonEscala || '')
        .toString()
        .split('|')
        .map((item: string) => item.trim());
      
      this.valNotNullAddress('origenAddr');
      this.valNotNullAddress('destinoAddr');

      this.resetParadas(this.EditarTabuladoForm);
      
      if (escalaPartes.length > 0) {
        const paradas = this.getParadasFormArray(this.EditarTabuladoForm);
        escalaPartes.slice(0, this.maxParadas).forEach((texto: string, index: number) => {
          if (index >= paradas.length) {
            this.agregarParada(this.EditarTabuladoForm);
            this.valNotNullAddress('escalaAddr',index)
          }
          const parada = paradas.at(index) as FormGroup;
          const latValue = parseFloat(latEscalaPartes[index] || '');
          const lonValue = parseFloat(lonEscalaPartes[index] || '');
          parada.patchValue({
            texto,
            lat: Number.isFinite(latValue) ? latValue : null,
            lng: Number.isFinite(lonValue) ? lonValue : null
          });
        });
        this.syncEscalaControl(this.EditarTabuladoForm);
      }
      this.EditarTabuladoForm.controls['kilometros'].setValue(this.datoseditartabulador[0].num_kilometros);
      this.EditarTabuladoForm.controls['hrs_carga_descarga'].setValue(this.datoseditartabulador[0].horas_cargaydescarga);
      this.EditarTabuladoForm.controls['num_choferes'].setValue(this.datoseditartabulador[0].num_choferes);
      this.EditarTabuladoForm.controls['num_auxiliares'].setValue(this.datoseditartabulador[0].num_auxiliares);
      this.EditarTabuladoForm.controls['porcentaje_UTD'].setValue(this.datoseditartabulador[0].num_porcentajeutd);

      this.TipoClienteSeleccionado = this.datoseditartabulador[0].id_tipo_cliente;
      this.EditarTabuladoForm.controls['tipo_cliente'].setValue(this.datoseditartabulador[0].id_tipo_cliente);
      this.EditarTabuladoForm.controls['comision_cliente'].setValue(this.datoseditartabulador[0].imp_terceros);

      this.EditarTabuladoForm.controls['hrs_traslado_carga'].setValue(this.datoseditartabulador[0].horas_trasladocarga);
      this.EditarTabuladoForm.controls['hrs_traslado_carga'].disable();
      this.EditarTabuladoForm.controls['hrs_espera_salida'].setValue(this.datoseditartabulador[0].horas_esperasalida);
      this.EditarTabuladoForm.controls['hrs_retorno_base'].setValue(this.datoseditartabulador[0].horas_retornobase);
      this.EditarTabuladoForm.controls['hrs_retorno_base'].disable();
      this.EditarTabuladoForm.controls['hrs_pernocta'].setValue(this.datoseditartabulador[0].num_horas_pernocta);

      this.EditarTabuladoForm.controls['id_modo_ruta'].setValue(this.datoseditartabulador[0].id_modo_ruta);
      
      const idCiudad = this.datoseditartabulador[0].id_ciudad_in ?? this.datoseditartabulador[0].id_ciudad ?? null;
      this.EditarTabuladoForm.controls['centro_costos'].setValue(idCiudad);

      const ciudadObj = (this.centrosCostosHm || []).find((c: any) => c.id == idCiudad);
      this.datoseditartabulador[0].nom_ciudad = ciudadObj ? ciudadObj.municipio : 'N/A';
      this.TablaRespuestaEditar = [...this.datoseditartabulador];

      this.EditarTabuladoForm.controls['es_truck'].setValue(this.datoseditartabulador[0].clv_truck ?? 0);
      this.EditarTabuladoForm.controls['num_stop'].setValue(this.datoseditartabulador[0].num_stop ?? 0);
      this.EditarTabuladoForm.controls['maniobras'].setValue(this.datoseditartabulador[0].clv_maniobras ?? 0);

      const valorPerfil = this.datoseditartabulador[0].id_perfil_ruta;
      this.EditarTabuladoForm.controls['perfilRuta'].setValue(valorPerfil);
      this.EditarTabuladoForm.controls['num_dias_frecuencia'].setValue(this.datoseditartabulador[0].num_dias_frecuencia);
      this.EditarTabuladoForm.controls['num_dias_dec'].setValue(this.datoseditartabulador[0].num_dias_dec); // SE AGREGA CAMPO num_dias_dec

      this.onPerfilRutaChangeDropdown({ value: valorPerfil });
      this.loading = false;
      this.dspEditarTAbulado = true;
    }, 200);
  });
}

  guardarFrmCotizacion(){
    let data_enviar={
      nom_contacto:this.CotizacionForm.get('nom_Contacto')?.value,
      num_diasoperativos:this.CotizacionForm.get('num_DiasOperativos')?.value,
      fec_emision:this.CotizacionForm.get('fecha_emision')?.value,
      id_jornadaoperacion:this.CotizacionForm.get('id_jornadaOperacion')?.value,
      hrs_esperadescarga:this.CotizacionForm.get('hrs_EsperaDescarga')?.value,
      hrs_advertencia:this.CotizacionForm.get('hrs_Advertencia')?.value,
      num_porcentajefletefalso:this.CotizacionForm.get('num_porcentajeFleteFalso')?.value,
      num_porcentajefleteretorno:this.CotizacionForm.get('num_porcentajeFleteRetorno')?.value,
      num_diasdecredito:this.CotizacionForm.get('num_diasCredito')?.value,
      id_tipoevento:this.CotizacionForm.get('id_tipoEvento')?.value,
      num_vigenciatarifaria:this.CotizacionForm.get('num_VigenciaTarifaria')?.value,
      num_diasvalidez:this.CotizacionForm.get('num_DiasValidez')?.value,
      idx_tabulador:this.idx_tabulador,
      num_cantidadrepartos:this.CotizacionForm.get('num_cantidadrepartos')?.value
    }
    this.tabuladorService.saveFormularioCotizacion(data_enviar).subscribe((resp)=>{
      var res=resp;
      setTimeout(() => {
        this.bntDescargarCotizacion=true;
        this.GetCotizacion();
        this.message.add({ key: 'msj', severity: 'success', summary: 'Guardado con Exito', detail: 'Operacion Realizada' });
      }, 250);
    })
  }

  ObtenerConfiguracionUnidades() {
    this.ClienteProspectoService.getConfiguracionUnidades().subscribe((resp) => {
      this.cat_ConfiguracionUnidades = resp
      setTimeout(() => {
      }, 300);
    })
  }
  
  ObtenerOracionesJornada(){
    this.tabuladorService.getOracionesJornada().subscribe((resp)=>{
      this.cat_diasoperacion=resp;
      setTimeout(() => {
        
      }, 200);
    })
  }
  ObtenerPeriodoFacturacion(){
    this.tabuladorService.getPeriodoFacturacion().subscribe((resp)=>{
      this.cat_periodofacturacion=resp;
      setTimeout(() => {
        
      }, 150);
    })
  }

  ObtenerTiposRuta(){
    this.tabuladorService.getTipoRuta().subscribe({
      next: (resp) => {
        this.cat_Rutas = resp || [];
      },
      error: (error) => {
        console.error('Error al cargar tipos de ruta', error);
        this.cat_Rutas = [];
      }
    });
  }

  GetContactoConID(id:number){
    this.ClienteProspectoService.getContactoEmpresa(id).subscribe((resp) => {
      this.contactoEmpresaObj = resp;
      this.cat_nombresContacto=this.contactoEmpresaObj.map(valor=>({
        NombreCompletoCto:valor.des_nombre+' '+valor.des_apellidopaterno+' '+valor.des_apellidomaterno
      }))
      setTimeout(() => {
      }, 200);
    })
  }

  GetCotizacion(){
    this.tabuladorService.GetCotizacion(this.idx_tabulador).subscribe((resp)=>{
      this.Obj_Cotizacion=resp;
        setTimeout(() => {
          this.GetContactoConID(this.IdClienteGlobal);
          this.CotizacionForm.controls['nom_Contacto'].setValue(this.Obj_Cotizacion[0].nom_contacto);
          this.CotizacionForm.controls['num_DiasOperativos'].setValue(this.Obj_Cotizacion[0].num_diasoperativos);
          this.CotizacionForm.controls['id_jornadaOperacion'].setValue(Number(this.Obj_Cotizacion[0].id_jornadaoperacion));
          this.CotizacionForm.controls['hrs_EsperaDescarga'].setValue(this.Obj_Cotizacion[0].hrs_esperadescarga);
          this.CotizacionForm.controls['hrs_Advertencia'].setValue(this.Obj_Cotizacion[0].hrs_advertencia);
          this.CotizacionForm.controls['num_porcentajeFleteFalso'].setValue(this.Obj_Cotizacion[0].num_porcentajefletefalso);
          this.CotizacionForm.controls['num_porcentajeFleteRetorno'].setValue(this.Obj_Cotizacion[0].num_porcentajefleteretorno);
          this.CotizacionForm.controls['num_diasCredito'].setValue(this.Obj_Cotizacion[0].num_diasdecredito);
          this.CotizacionForm.controls['id_tipoEvento'].setValue(Number(this.Obj_Cotizacion[0].id_tipoevento));
          this.CotizacionForm.controls['num_VigenciaTarifaria'].setValue(this.Obj_Cotizacion[0].num_vigenciatarifaria);
          this.CotizacionForm.controls['num_DiasValidez'].setValue(this.Obj_Cotizacion[0].num_diasvalidez);
        }, 150);
    })
  }

  verTabuladorDiario(idxs: number): void {
    this.tabuladorService.GetDiarioTabulador(idxs).subscribe(
        (data: ITabuladorDiario[]) => {
            this.tabuladorDiarioData = data; 
            this.dspTabuladorDiario = true; 
        },
        (error) => {
            console.error('Error al obtener el tabulador diario:', error);
        }
    );
  }

  VerFrmCotizacion(data:any) {
    this.idx_tabulador=data.idx;
    var getYear = new Date().toLocaleDateString('es-MX', { year: 'numeric' });
    var getMonth = new Date().toLocaleDateString('es-MX', { month: '2-digit' });
    var getDay = new Date().toLocaleDateString('es-MX', { day: '2-digit' });
    var dateFormat = getYear + "-" + getMonth + "-" + getDay;
    let fecha = dateFormat;
    this.CotizacionForm.controls['fecha_emision'].setValue(fecha);
    this.tabuladorService.GetCotizacion(this.idx_tabulador).subscribe((resp)=>{
      this.Obj_Cotizacion=resp;
      if(resp.length>0){
        setTimeout(() => {
          this.GetContactoConID(this.IdClienteGlobal);
          this.CotizacionForm.controls['nom_Contacto'].setValue(this.Obj_Cotizacion[0].nom_contacto);
          this.CotizacionForm.controls['num_DiasOperativos'].setValue(this.Obj_Cotizacion[0].num_diasoperativos);
          this.CotizacionForm.controls['id_jornadaOperacion'].setValue(Number(this.Obj_Cotizacion[0].id_jornadaoperacion));
          this.CotizacionForm.controls['hrs_EsperaDescarga'].setValue(this.Obj_Cotizacion[0].hrs_esperadescarga);
          this.CotizacionForm.controls['hrs_Advertencia'].setValue(this.Obj_Cotizacion[0].hrs_advertencia);
          this.CotizacionForm.controls['num_porcentajeFleteFalso'].setValue(this.Obj_Cotizacion[0].num_porcentajefletefalso);
          this.CotizacionForm.controls['num_porcentajeFleteRetorno'].setValue(this.Obj_Cotizacion[0].num_porcentajefleteretorno);
          this.CotizacionForm.controls['num_diasCredito'].setValue(this.Obj_Cotizacion[0].num_diasdecredito);
          this.CotizacionForm.controls['id_tipoEvento'].setValue(Number(this.Obj_Cotizacion[0].id_tipoevento));
          this.CotizacionForm.controls['num_VigenciaTarifaria'].setValue(this.Obj_Cotizacion[0].num_vigenciatarifaria);
          this.CotizacionForm.controls['num_DiasValidez'].setValue(this.Obj_Cotizacion[0].num_diasvalidez);
          this.CotizacionForm.controls['num_cantidadrepartos'].setValue(this.Obj_Cotizacion[0].num_cantidadrepartos);
          this.bntDescargarCotizacion=true;
          this.dspFrmCotizacion=true;
        }, 200);
      }else{
        this.GetContactoConID(this.IdClienteGlobal);
        this.dspFrmCotizacion=true;
      }
    })
  }
  CerrarFrmCotizacion() {
    this.CotizacionForm.reset();
    this.Obj_Cotizacion=[];
    this.bntDescargarCotizacion=false;
    this.dspFrmCotizacion = false;
  }

  GenerarCotizacion(){
    let idxs=this.idx_tabulador;
    this.tabuladorService.GenerateCotizacionPDF(idxs).subscribe(
      (archivo: Blob) => {
        const archivoUrl = URL.createObjectURL(archivo);

        const link = document.createElement('a');
        link.setAttribute('target', '_blank');
        link.setAttribute('href', archivoUrl);

        document.body.appendChild(link);
        link.click();
        link.remove();
      },
      error => {
        console.error('Error al obtener archivo:', error);
      }
    )
  }

  setProspecto() {
    if (this.IdClienteGlobal == null && this.NombreEmpresaGlobal == null) {
      this.IdClienteGlobal = this.setidGlobal;
      this.NombreEmpresaGlobal = this.NombreEmpresaGlobal;
    } else {
      this.setidGlobal = this.IdClienteGlobal;
      this.setnomGlobal = this.NombreEmpresaGlobal;
    }
  }
  actualizarLabelTexto() {
    this.texto = this.isListView ? 'Ver como Tabla' : 'Ver como Lista';
  }

  ObtenerMunicipios() {
    this.tabuladorService.getMunicipios().subscribe((resp) => {
      this.municipioscat = resp;
      setTimeout(() => {
      }, 400);
    })
  }

  ObtenerCiudadesHm() {
    this.ClienteProspectoService.getCiudadesHm().subscribe((resp) => {
      const data: any[] = resp || [];
      this.centrosCostosHm = data
        .map((item: any) => ({
          ...item,
          id: item.id ?? item.id_ciudad ?? item.idCiudad ?? item.clv_ciudad ?? item.clave_ciudad ?? item.id_ciudad_principal ?? null,
          municipio: item.municipio ?? item.nombre ?? item.ciudad ?? ''
        }))
        .filter((item: any) => (item.municipio || '').toString().trim() !== '');
      setTimeout(() => {
      }, 400);
    })
  }
  cancelarVentanaVerDetallado(){
    this.dspVerDetallado=false;
  }

  ObtenerPropuestaEstatus(){
    this.tabuladorService.getPropuestaEstatus().subscribe((resp)=>{
      this.cat_estatuspropuesta=resp;
      setTimeout(() => {
      }, 600);
    })
  }

  SetDropDown(data: ITabuladorCostos) {
    this.valorEstatus = data.id_estatuspropuesta;
  }

ObtenerTablaPrincipal() {
    this.loading = true; 
    this.tabuladorService.getTabuladorPrincipal(this.IdClienteGlobal).subscribe(
      (resp) => {
        this.TabuladorCostos = resp;
        this.checkHospedajeColumn();

        setTimeout(() => {
            this.loading = false; 
        }, 500); 
      }, 
      (error) => { 
        console.error('Error al cargar tabulador principal', error);
        this.loading = false; 
      }
    );
  }

  ModificarEstatus(data:ITabuladorCostos){

  }

  VerGrafica(data: ITabuladorCostos) {
    this.costoGlobal = data.costo;
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    const originalData = [
      data.imp_comisioncombustible,
      data.imp_sueldochofer,
      data.imp_sueldoaux,
      data.imp_combustible,
      data.imp_cel_gps,
      data.imp_imss,
      data.imp_hospedaje,
      data.imp_viaticos,
      data.imp_depreciacion,
      data.imp_urea,
      data.imp_mantenimiento,
      data.imp_peaje,
      data.imp_comisionvendedor,
      data.imp_llantas,
    ].map(value => value || 0);
    const totalOriginal = originalData.reduce((sum, value) => sum + value, 0);

    const normalizedData = totalOriginal > 0 ? originalData.map(value => (value / totalOriginal) * data.costo) : originalData.map(() => 0);

    this.data = {
      labels: [
        'Comision Combustible: $' + normalizedData[0].toFixed(2),
        'Sueldo Chofer: $' + normalizedData[1].toFixed(2),
        'Sueldo Auxiliar: $' + normalizedData[2].toFixed(2),
        'Combustible: $' + normalizedData[3].toFixed(2),
        'Importe Celular GPS: $' + normalizedData[4].toFixed(2),
        'IMSS: $' + normalizedData[5].toFixed(2),
        'Hospedaje: $' + normalizedData[6].toFixed(2),
        'Viaticos: $' + normalizedData[7].toFixed(2),
        'Depreciacion: $' + normalizedData[8].toFixed(2),
        'Urea: $' + normalizedData[9].toFixed(2),
        'Mantenimiento: $' + normalizedData[10].toFixed(2),
        'Peaje: $' + normalizedData[11].toFixed(2),
        'Comision del Vendedor: $' + normalizedData[12].toFixed(2),
        'Importe de llantas: $' + normalizedData[13].toFixed(2)
      ],
      datasets: [
        {
          data: normalizedData,
          backgroundColor: [
            documentStyle.getPropertyValue('--yellow-500'),
            documentStyle.getPropertyValue('--green-500'),
            documentStyle.getPropertyValue('--orange-500'),
            documentStyle.getPropertyValue('--gray-500'),
            documentStyle.getPropertyValue('--purple-500'),
            documentStyle.getPropertyValue('--black-500'),
            documentStyle.getPropertyValue('--pink-500'),
            documentStyle.getPropertyValue('--indigo-500'),
            documentStyle.getPropertyValue('--purple-300'),
            documentStyle.getPropertyValue('--brown-500'),
            documentStyle.getPropertyValue('--yellow-300'),
            documentStyle.getPropertyValue('--blue-400')
          ],
          hoverBackgroundColor: [
            documentStyle.getPropertyValue('--yellow-400'),
            documentStyle.getPropertyValue('--green-400'),
            documentStyle.getPropertyValue('--orange-400'),
            documentStyle.getPropertyValue('--gray-400'),
            documentStyle.getPropertyValue('--purple-400'),
            documentStyle.getPropertyValue('--black-400'),
            documentStyle.getPropertyValue('--pink-400'),
            documentStyle.getPropertyValue('--indigo-400'),
            documentStyle.getPropertyValue('--purple-400'),
            documentStyle.getPropertyValue('--brown-400'),
            documentStyle.getPropertyValue('--yellow-400'),
            documentStyle.getPropertyValue('--blue-500')
          ]
        }
      ]
    };

    this.options = {
      responsive: true,
      cutout: '65%',
      plugins: {
        datalabels: {
          display: false
        },
        legend: {
          display: true,
          position: 'right',
          labels: {
            color: textColor,
            font: {
              size: 14,
              weight: 'bold'
            }
          }
        },
        tooltip: {
          enabled: true,
          mode: 'index',
          intersect: false,
          callbacks: {
            label: function (context: any) {
              let label = context.label || '';
              if (label) {
                label += ': ';
              }
              if (context.raw !== null) {
                label = context.label;
              }
              return label;
            }
          }
        }
      },
      animation: {
        display: true,
        enabled: true,
        animateScale: true,
        animateRotate: true
      }
    };
    this.dspGrafica = true;
  }
  
  public TraspasarTabla(data: any) {
    this.tablaExportar = [];
    let obj: any;
    obj = this.cat_Rutas.find(objeto => objeto.id_area === data.id_tiporuta);
    let kampo: string = '';
    if (obj) {
      if (obj.nom_area) {
        kampo = obj.nom_area
        this.tablaExportar.push({
          Ciudad: data.nom_ciudad,
          Cliente: this.NombreEmpresaGlobal,
          Unidad: data.config_unidad, 
          Origen: data.des_origen,
          Destino: data.des_destino,
          Escala: data.des_escala,
          Tipo_Ruta: kampo,
          Km: data.num_kilometros,
          Peaje: data.imp_peaje,
          Horas_Carga: data.num_horas,
          Horas_Descarga: data.horas_esperasalida,
          Horas_Intermedia: data.horas_retornobase,
          Horas_Descanso: data.hrs_descanso,
          Horas_Pernocta: data.num_horas_pernocta,
          Horas_Carga_Combustible: data.num_horas_carga_combustible,
          Horas_Entre_Servicio: data.horas_entreservicio,
          Numero_Operadores: data.num_choferes,
          Numero_Auxiliares: data.num_auxiliares,
          Numero_Dias_Reales_Dec: data.num_dias_dec,
          Numero_Dias_Reales: data.num_dias,
          Numero_Dias_Para_Venta: data.num_dias_de_ruta,
          Costo: data.costo,
          PDV: data.imp_preciodeventa,
          Utilidad: data.imp_utilidad,
          Dias_de_frecuencia: data.num_dias_frecuencia,
          Precio_de_frecuencia: data.imp_precio_de_frecuencia,
          Porcentaje_UTD: (data.num_porcentajeutd + '%'),
          Porcentaje_imp_terceros: (data.imp_terceros + '%'),
          Comision_a_Terceros: data.imp_comision_tercero,
          PDV_mas_Comision_de_terceros: data.imp_pdv_comision_terceros,
          Num_Stop:data.num_stop_in,
          Imp_Stop:data.imp_stop,
          Maniobras:data.clv_maniobras_in==1?'SI':'NO',
          Imp_Maniobras:data.imp_maniobras,
          Truck:data.clv_truck_in==1?'SI':'NO',
          Costo_km:data.imp_costo_kilometros,
          Sueldo_Chofer: data.imp_sueldochofer,
          Imp_SueldoTotalChofer:data.sueldo_total_chofer,
          Sueldo_Aux: data.imp_sueldoaux,
          Gasto_Hospedaje: data.imp_hospedaje,
          Gasto_Viaticos: data.imp_viaticos,
          Gasto_Combustible: data.imp_combustible,
          Gasto_Comision_Combustible: data.imp_comisioncombustible,
          Gasto_Urea: data.imp_urea,
          Gasto_GPS: data.imp_cel_gps,
          IMSS: data.imp_imss,
          Vehiculos: data.imp_depreciacion,
          Mantenimiento_Preventivo: data.imp_mantenimiento,
          Servicios_Correctivos: data.imp_serviciocorrectivo,
          Propuesta_Valor: data.imp_propuestavalor,
          Permisos_Circulacion: data.imp_permisocirculacion,
          costo_urea_sin_iva_peaje: data.imp_costo_urea_sin_iva_peaje,
          imp_utilidad_con_urea_sin_iva_peaje: data.imp_utilidad_urea_sin_iva_peaje,
          num_porcentaje_margen: data.num_margen,
          imp_llantas: data.imp_llantas,
          id_modo_ruta: data.id_modo_ruta === 1 ? 'RT' : data.id_modo_ruta === 2 ? 'OW' : '',
          id_perfil_ruta: data.id_perfil_ruta === 1 ? 'ZONA INDUSTRIAL' : data.id_perfil_ruta === 2 ? 'ZONA METROPOLITANA' : '',
          imp_perfil_ruta: data.imp_perfil_ruta,
          Modo_Cotizador: data.id_tipo_tabulado === 1 ? 'GLOBAL MAPS' : data.id_tipo_tabulado === 2 ? 'SISTEMA' : '',
        })
      }
    } 
    return this.tablaExportar
  }
  public TraspasarTablaobj(data: any[]):any[] {
    this.tablaExportar = [];
    this.tablaExportar = data.map(element => {
      let found = this.cat_Rutas.find(objeto => objeto.id_area === element.id_tiporuta);
      if(found){
        if(found.nom_area){
          this.kampo=found.nom_area;
        }
      }

      return {
        Ciudad: element.nom_ciudad,
        Cliente: this.NombreEmpresaGlobal,
        Unidad: element.config_unidad, 
        Origen: element.des_origen,
        Destino: element.des_destino,
        Escala: element.des_escala,
        Tipo_Ruta: this.kampo,
        Km: element.num_kilometros,
        Peaje: element.imp_peaje,
        Horas_Carga: element.num_horas,
        Horas_Descarga: element.horas_esperasalida,
        Horas_Intermedia: element.horas_retornobase,
        Horas_Descanso: element.hrs_descanso,
        Horas_Pernocta: element.num_horas_pernocta,
        Horas_Carga_Combustible: element.num_horas_carga_combustible,
        Horas_Entre_Servicio: element.horas_entreservicio,
        Numero_Operadores: element.num_choferes,
        Numero_Auxiliares: element.num_auxiliares,
        Numero_Dias_Reales_Dec: element.num_dias_dec,
        Numero_Dias_Reales: element.num_dias,
        Numero_Dias_Para_Venta: element.num_dias_de_ruta,
        Costo: element.costo,
        PDV: element.imp_preciodeventa,
        Utilidad: element.imp_utilidad,
        Dias_de_frecuencia: element.num_dias_frecuencia,
        Precio_de_frecuencia: element.imp_precio_de_frecuencia,
        Porcentaje_UTD: (element.num_porcentajeutd + '%'),
        Porcentaje_imp_terceros: (element.imp_terceros + '%'),
        Comision_a_Terceros: element.imp_comision_tercero,
        PDV_mas_Comision_de_terceros: element.imp_pdv_comision_terceros,
        Num_Stop:element.num_stop_in,
        Imp_Stop:element.imp_stop,
        Maniobras:element.clv_maniobras_in==1?'SI':'NO',
        Imp_Maniobras:element.imp_maniobras,
        Truck:element.clv_truck_in==1?'SI':'NO',
        Costo_km:element.imp_costo_kilometros,
        Sueldo_Chofer: element.imp_sueldochofer,
        Imp_SueldoTotalChofer:element.sueldo_total_chofer,
        Sueldo_Aux: element.imp_sueldoaux,
        Gasto_Hospedaje: element.imp_hospedaje,
        Gasto_Viaticos: element.imp_viaticos,
        Gasto_Combustible: element.imp_combustible,
        Gasto_Comision_Combustible: element.imp_comisioncombustible,
        Gasto_Urea: element.imp_urea,
        Gasto_GPS: element.imp_cel_gps,
        IMSS: element.imp_imss,
        Vehiculos: element.imp_depreciacion,
        Mantenimiento_Preventivo: element.imp_mantenimiento,
        Servicios_Correctivos: element.imp_serviciocorrectivo,
        Propuesta_Valor: element.imp_propuestavalor,
        Permisos_Circulacion: element.imp_permisocirculacion,
        costo_urea_sin_iva_peaje: element.imp_costo_urea_sin_iva_peaje,
        imp_utilidad_con_urea_sin_iva_peaje: element.imp_utilidad_urea_sin_iva_peaje,
        num_porcentaje_margen: element.num_margen,
        imp_llantas: element.imp_llantas,
        id_modo_ruta: element.id_modo_ruta === 1 ? 'RT' : element.id_modo_ruta === 2 ? 'OW' : '',
        id_perfil_ruta: element.id_perfil_ruta === 1 ? 'ZONA INDUSTRIAL' : element.id_perfil_ruta === 2 ? 'ZONA METROPOLITANA' : '',
        imp_perfil_ruta: element.imp_perfil_ruta,
        Modo_Cotizador: element.id_tipo_tabulado === 1 ? 'GLOBAL MAPS' : element.id_tipo_tabulado === 2 ? 'SISTEMA' : '',
      };
    });
    return this.tablaExportar
  }

  getTooltipEstatus(data: any): string {
    if (data.clv_enviado === 1) return 'Aprobado y Enviado';
    if (data.pendiente_gerente) return 'Enviado a revisión de Gerente';
    if (data.clv_candado_hrs === 1) return 'Requiere Autorización de Gerente';
    return 'No Enviado';
  }
Mostrar(data: any) {
  this.data_tabulador = data;
  this.opcTabulado = [
    { label: 'Ver Información', icon: 'pi pi-info-circle', command: () => { this.verTabuladorDiario(this.data_tabulador.idx); } },
    { label: 'Generar Cotización', icon: 'pi pi-briefcase', command: () => { this.VerFrmCotizacion(this.data_tabulador); } },
    { label: 'Editar Tabulado', icon: 'pi pi-file-edit', command: () => { this.EditarTabulado(this.data_tabulador); } },
    { separator: true },
    {
      label: 'Ofrecer la Ruta',
      icon: 'pi pi-directions',
      command: () => {
        if (this.data_tabulador.clv_enviado === 1) {
          this.validarYAbrirOfrecerRuta(this.data_tabulador);
        } else {
          this.message.add({ key: 'msj', severity: 'warn', summary: 'Ruta no enviada', detail: 'La ruta debe estar aprobada para ofrecerla.' });
        }
      }
    }
  ];

  if (data.clv_enviado === 2) {
    this.opcTabulado.push({
      label: 'Autorizar (Gerente)',
      icon: 'pi pi-check-circle',
      styleClass: 'menu-autorizar-gerente', 
      command: () => { 
        this.AutorizarComoGerente(data); 
      }
    });
  }
}

onEstatusPropuestaChange(event: any, data: any) {

  if (!event.target.checked) return;


  if (data.clv_candado_hrs === 1) {
    
    this.confirmationService.confirm({
      message: 'Esta ruta excede los límites permitidos. ¿Deseas solicitar la <b>Autorización del Gerente</b>?',
      header: 'Requiere Autorización',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Solicitar',
      rejectLabel: 'Cancelar',
      acceptButtonStyleClass: 'p-button-warning',
      accept: () => {
        
        let data_enviar = { 
          idx: data.idx, 
          clv_enviado: 2 
        }; 

        this.tabuladorService.updateEstatus(data_enviar).subscribe({
          next: () => {
            data.clv_enviado = 2; 
            this.message.add({ key: 'msj', severity: 'info', summary: 'Aviso', detail: 'Ruta enviada a revisión del gerente.' });
          },
          error: () => {
            event.target.checked = false;
            this.message.add({ key: 'msj', severity: 'error', summary: 'Error', detail: 'No se pudo procesar.' });
          }
        });

      },
      reject: () => { event.target.checked = false; }
    });

  } 
  else {
    
    this.confirmationService.confirm({
      message: '¿Estás seguro que deseas enviar definitivamente este tabulado?',
      header: 'Confirmar Envío',
      icon: 'pi pi-check-square',
      acceptLabel: 'Aceptar y Enviar',
      rejectLabel: 'Cancelar',
      acceptButtonStyleClass: 'p-button-success',
      accept: () => {
        
        let data_enviar = { 
          idx: data.idx,
          clv_enviado: 1 
        };

        this.tabuladorService.updateEstatus(data_enviar).pipe(
          switchMap(respSaveInfo => {
            return new Observable(observer => {
              let objetopasar = {
                id_cte_prospecto: data.id_cte_prospecto,
                id_estatus: 5 
              };
              this.ClienteProspectoService.saveMovimientoEstatus(objetopasar).subscribe(() => {
                observer.next();
                observer.complete();
              });
            });
          })
        ).subscribe({
          next: () => {
            data.clv_enviado = 1; 
            this.message.add({ key: 'msj', severity: 'success', summary: 'Aprobado', detail: 'Tabulado aprobado correctamente.' });
          },
          error: () => {
            event.target.checked = false;
            this.message.add({ key: 'msj', severity: 'error', summary: 'Error', detail: 'No se pudo completar.' });
          }
        });
      },
      reject: () => { event.target.checked = false; }
    });
  }
}

AutorizarComoGerente(data: any) {
  this.confirmationService.confirm({
    message: '¿Estás seguro de autorizar esta ruta como Gerente?',
    header: 'Autorización de Gerencia',
    icon: 'pi pi-shield',
    acceptLabel: 'Autorizar',
    rejectLabel: 'Cancelar',
    acceptButtonStyleClass: 'p-button-success',
    accept: () => {
      
      let payload = {
        idx: data.idx,
        cod_usuario: this.usuario.cod 
      };


      this.tabuladorService.autorizarRutaGerente(payload).subscribe({
        next: (resp: any) => {
          if (resp.clv_estatus === 1) {
            this.message.add({ key: 'msj', severity: 'success', summary: 'Autorizado', detail: resp.messageDetails });
            

            data.clv_enviado = 1; 
            data.clv_aceptado_gte = 1;
            
    
            this.ObtenerTablaPrincipal();
          } else {

            this.message.add({ key: 'msj', severity: 'error', summary: 'Acceso Denegado', detail: resp.messageDetails });
          }
        },
        error: (err) => {
          this.message.add({ key: 'msj', severity: 'error', summary: 'Error', detail: 'Fallo al conectar con el servidor.' });
        }
      });
    }
  });
}

CerrarGrafica(){
  this.dspGrafica=false;
}

GenerarTodoAExcel() {

  if (this.TabuladorCostos.length === 0) {
    this.message.add({
      key: 'msj',
      severity: 'warn',
      summary: 'No Existen Tabulados',
      detail: 'No Existen Tabulados para Exportar'
    });
    return;
  }

  const data = this.TraspasarTablaobj(this.TabuladorCostos);

  const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data, { origin: 'A3' } as any);

  XLSX.utils.sheet_add_aoa(worksheet, [
    [`Cliente Prospecto: ${this.NombreEmpresaGlobal}`]
  ], { origin: 'A1' });

  const headerRowIndex = 2;
  const range = XLSX.utils.decode_range(worksheet['!ref']!);
  const headers = Object.keys(data[0]);

  // 🎯 ESTILOS COMPLETOS
  for (let R = headerRowIndex; R <= range.e.r; ++R) {
    for (let C = range.s.c; C <= range.e.c; ++C) {

      const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
      if (!worksheet[cellRef]) continue;

      const columnName = headers[C];

      // 🔷 HEADER
      if (R === headerRowIndex) {
        worksheet[cellRef].s = {
          font: {
            bold: true,
            color: { rgb: "FFFFFFFF" }
          },
          fill: {
            patternType: "solid",
            fgColor: { rgb: "FF1F4E78" }
          },
          alignment: {
            horizontal: "center",
            vertical: "center"
          },
          border: {
            top: { style: "thin", color: { rgb: "FFFFFFFF" } },
            bottom: { style: "thin", color: { rgb: "FFFFFFFF" } },
            left: { style: "thin", color: { rgb: "FFFFFFFF" } },
            right: { style: "thin", color: { rgb: "FFFFFFFF" } }
          }
        };
        continue;
      }

      // 🔹 FILAS
      worksheet[cellRef].s = {
        font: { name: 'Arial', sz: 10 },
        alignment: {
          vertical: "center",
          horizontal: typeof worksheet[cellRef].v === 'number' ? "right" : "left"
        },
        border: {
          top: { style: "thin", color: { rgb: "FFD9D9D9" } },
          bottom: { style: "thin", color: { rgb: "FFD9D9D9" } },
          left: { style: "thin", color: { rgb: "FFD9D9D9" } },
          right: { style: "thin", color: { rgb: "FFD9D9D9" } }
        }
      };

      // 🎨 Zebra
      if (R % 2 === 0) {
        worksheet[cellRef].s.fill = {
          patternType: "solid",
          fgColor: { rgb: "FFF7F9FC" }
        };
      }

      // 💰 FORMATO INTELIGENTE
      if (typeof worksheet[cellRef].v === 'number') {

        if (columnName === 'Km') {
          worksheet[cellRef].z = '0'; // kilómetros sin $
        } 
        else {
          worksheet[cellRef].z = '$#,##0.00';
        }
      }
    }
  }

  // 🎯 MERGE DINÁMICO
  const totalColumns = headers.length;

  worksheet['!merges'] = [
    {
      s: { r: 0, c: 0 },
      e: { r: 0, c: totalColumns - 1 }
    }
  ];

  // 🔒 Freeze header
  worksheet['!freeze'] = { xSplit: 0, ySplit: 3 };

  // 🎨 TÍTULO
  const titleRef = XLSX.utils.encode_cell({ c: 0, r: 0 });

  if (worksheet[titleRef]) {
    worksheet[titleRef].s = {
      font: {
        name: 'Arial',
        sz: 14,
        bold: true,
        color: { rgb: "FFFFFFFF" }
      },
      fill: {
        patternType: "solid",
        fgColor: { rgb: "FF0F2A44" }
      },
      alignment: {
        horizontal: "left",
        vertical: "center"
      }
    };
  }

  // 📏 COLUMNAS
  worksheet['!cols'] = headers.map((h) => ({
    wch: Math.max(h.length + 5, 15)
  }));

  // 📦 EXPORTAR
  const workbook: XLSX.WorkBook = {
    Sheets: { 'data': worksheet },
    SheetNames: ['data']
  };

  const excelBuffer: any = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array'
  });

  const fecha = new Date().toISOString().split('T')[0];

  this.saveExcelFile(excelBuffer, 'Tabulador_de_Costos_' + fecha);
}

GenerarExcel(data: any) {

    const exportData = this.TraspasarTabla(data); 

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);

    XLSX.utils.sheet_add_json(worksheet, exportData, { origin: "A3", skipHeader: false });
    
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet([
      [`Cliente Prospecto: ${this.NombreEmpresaGlobal}`],
      [] 
    ]);


    XLSX.utils.sheet_add_json(ws, exportData, { origin: 'A3', skipHeader: false });

    const headerRowIndex = 2; 

    const range = XLSX.utils.decode_range(ws['!ref']!);

    for (let C = range.s.c; C <= range.e.c; ++C) {
      const cellAddress = { c: C, r: headerRowIndex };
      const cellRef = XLSX.utils.encode_cell(cellAddress);
      
      if (!ws[cellRef]) continue;

      ws[cellRef].s = {
        font: {
          name: 'Arial',
          sz: 12,
          bold: true,
          color: { rgb: "FFFFFFFF" }
        },
        fill: {
          patternType: "solid",
          fgColor: { rgb: "FF0000FF" }
        },
        border: {
          top: { style: "thin", color: { rgb: "FF000000" } },
          bottom: { style: "thin", color: { rgb: "FF000000" } },
          left: { style: "thin", color: { rgb: "FF000000" } },
          right: { style: "thin", color: { rgb: "FF000000" } }
        },
        alignment: {
          vertical: "center",
          horizontal: "center"
        }
      };
    }

    const titleRef = XLSX.utils.encode_cell({ c: 0, r: 0 });
    if (ws[titleRef]) {
      ws[titleRef].s = {
        font: { name: 'Arial', sz: 14, bold: true, color: { rgb: "000000" } },
        alignment: { horizontal: "left" }
      };
    }

    const workbook: XLSX.WorkBook = {
      Sheets: { 'data': ws },
      SheetNames: ['data']
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    });

    var getYear = new Date().toLocaleDateString('es-MX', { year: 'numeric' });
    var getMonth = new Date().toLocaleDateString('es-MX', { month: '2-digit' });
    var getDay = new Date().toLocaleDateString('es-MX', { day: '2-digit' });
    var fecha_registro_momento = getYear + "-" + getMonth + "-" + getDay;
    
    this.saveExcelFile(excelBuffer, 'Tabulador_de_Costos_' + this.NombreEmpresaGlobal + '_' + data.des_origen + '/' + data.des_destino + '_' + data.config_unidad + '_' + fecha_registro_momento + '');
  }

  private saveExcelFile(buffer: any, fileName: string): void {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    saveAs(data, `${fileName}.xlsx`);

  }
  getFiltradoMunicipios(event: any) {
    this.selectedValue = event.value;
    this.valor = event.value;
    this.tabuladorService.getMunicipiosFiltrados(this.selectedValue).subscribe((resp) => {
      this.MunicipiosFiltrados = resp;
      setTimeout(() => {

      }, 250);
    })
  }
  getListadoEstados() {
    this.ClienteProspectoService.getEstadosMunicipios().subscribe((resp) => {
      this.estados = resp;
      setTimeout(() => {
      }, 1000);
    })
  }

  getListadoMunicipios(event: any) {
    this.selectedValue = event.value;
    this.valor = event.value;
    this.ClienteProspectoService.getMunicipios(this.selectedValue).subscribe((resp) => {
      this.municipios = resp;
      setTimeout(() => {
      }, 1000);
    })
  }

  cargarInformacionUsuario() {
    this.usuario = this.auth.user;
  }

  obtenerDatos() {

  }

  ObtenerClientesProspecto() {
    this.ClienteProspectoService.getClientesProspecto().subscribe((resp) => {
      this.cat_clientesProspecto = resp;
      setTimeout(() => {
      }, 800);
    })
  }

  Tabular() {
    const allControls = [
        'configuracion_Unidad', 'Area', 'kilometros', 'hrs_carga_descarga',
        'hrs_traslado_carga', 'hrs_espera_salida', 'hrs_retorno_base', 'num_choferes',
        'num_auxiliares', 'porcentaje_UTD', 'tipo_cliente', 'origen', 'destino',
        'escala', 'imp_peajeindividual_extr', 'imp_porcentajecancelado_extr',
        'imp_descargaCompleta_extr', 'num_Personas_extr', 'imp_Persona_extr',
        'imp_Subcontrato_extr', 'comision_cliente', 'centro_costos', 'es_truck',
        'num_stop', 'maniobras', 'id_modo_ruta', 'perfilRuta', 'hrs_pernocta'
    ];
    allControls.forEach(controlName => this.tabuladorForm.get(controlName)?.disable());
    
    this.tabuladorForm.get('tipo_tabulado')?.enable();
    this.tabuladorForm.get('tipo_tabulado')?.setValue(1, { emitEvent: false });
    this.onTipoTabuladoChange({ value: 1 }, this.tabuladorForm);
    this.tabuladorForm.controls['imp_porcentajecancelado_extr'].setValue(40);
    this.tabuladorForm.controls['porcentaje_UTD'].setValue(35);
    this.tabuladorForm.controls['hrs_carga_descarga'].setValue(4);
    this.tabuladorForm.controls['hrs_traslado_carga'].setValue(4);
    this.tabuladorForm.controls['hrs_espera_salida'].setValue(0);
    this.tabuladorForm.controls['hrs_retorno_base'].setValue(0);
    this.tabuladorForm.controls['hrs_pernocta'].setValue(0);
    this.tabuladorForm.controls['tipo_cliente'].setValue(1);
    this.tabuladorForm.controls['num_choferes'].setValue(1);
    this.tabuladorForm.controls['num_auxiliares'].setValue(0);
    this.tabuladorForm.controls['comision_cliente'].setValue(0);
    this.tabuladorForm.controls['kilometros'].setValue(1);
    this.tabuladorForm.controls['num_stop'].setValue(0);
    this.tabuladorForm.controls['maniobras'].setValue(0);
    this.tabuladorForm.controls['es_truck'].setValue(0);
    this.tabuladorForm.get('num_dias_frecuencia')?.setValue(0);
    this.idruta = 2;
    this.tabuladorForm.get('Area')?.setValue(2);
    this.tabuladorForm.get('Area')?.setValidators(Validators.required);
    this.tabuladorForm.get('perfilRuta')?.setValue(1);
    this.tabuladorForm.controls['id_modo_ruta'].setValue(1);
    this.dspTabulador = true;
  }

  openNewWindow(pagina: string): void {
    window.open("//" + pagina, '_blank');
  }

  clear(table: Table) {
    table.clear(); 
    this.ObtenerTablaPrincipal();
  

    table.sortField = 'id_corrida'; 
    table.sortOrder = 1;

    table.selection = [];

    table.first = 0;
  }
  
GenerarNuevoTabulado() {
  this.tabuladorForm.reset();

  this.Tabular();
 
  this.tabuladorForm.controls['imp_porcentajecancelado_extr'].setValue(40);
  this.tabuladorForm.controls['imp_descargaCompleta_extr'].setValue(0);
  this.tabuladorForm.controls['num_Personas_extr'].setValue(0);
  this.tabuladorForm.controls['imp_Persona_extr'].setValue(0);
  this.tabuladorForm.controls['imp_peajeindividual_extr'].setValue(0);
  this.tabuladorForm.controls['imp_Subcontrato_extr'].setValue(0);  

  this.tabuladorForm.controls['TxtOrigen'].setValue('');
  this.tabuladorForm.controls['google_origen_address'].setValue(0);
  this.tabuladorForm.controls['TxtDestino'].setValue('');
  this.tabuladorForm.controls['google_destino_address'].setValue(0);

  this.googleOrigenSearch = '';
  this.googleDestinoSearch = '';
  this.googleEscalaSearch = '';
  this.TipoClienteSeleccionado = 0;

  this.importeSeleccionado = 0;
  this.configuracionesSeleccionadas = [];
  this.objImporteCaseta = [];
  this.importesForms = [];
  this.tablaRespuesta = [...this.tablaVacia];
  this.uniqueConfigurations = [...this.tablaVacia];
  
  // 1. Tipo de Ruta (FORANEA id=2)
  this.idruta = 2; 
  this.tabuladorForm.get('Area')?.setValue(2);

  // 2. Perfil de Ruta (INDUSTRIAL id=1)
  this.tabuladorForm.get('perfilRuta')?.setValue(1);
  this.onPerfilRutaChangeDropdown({ value: 1 }); // Actualiza el importe a 0

  // 3. Circuito (RT id=1)
  this.tabuladorForm.get('id_modo_ruta')?.setValue(1);

  this.dspTablaRegreso = false;
}
 GuardarTabulado(data: any) {
    if(data.imp_sueldochofer == 0)
    {
      this.confirmationService.confirm({
        message: 'No es posible almacenar este Costeo,' 
                +' ya que no existe información en la Base de Cobros para la ciudad,'
                +' el rango de kilómetros y la configuración de la unidad. Favor de revisar con el Administrador.',
        header: 'Advertencia',
        icon: 'pi pi-times-circle',
        acceptLabel: 'Ok',
        rejectVisible: false,
        accept: () => {} 
      });
    }
    else
    {
      let configu = this.cat_ConfiguracionUnidades.find(obj => obj.nombre === data.configuracion)
      let configvalor: number = 0;
      if (configu) {
        if (configu.clave_configuracionUnidad) {
          configvalor = configu.clave_configuracionUnidad;
        }
      }
    
      let estado = this.municipioscat.find(obj => obj.id === data.id_origen);
      let id_estado: number = 0;
      if (estado) {
        if (estado.id) {
          id_estado = estado.id;
        }
      }
      let muni = this.municipioscat.find(obj => obj.id === data.id_destino);
      let id_muni: number = 0;
      if (muni) {
        if (muni.id) {
          id_muni = muni.id;
        }
      }
      let esc = this.municipioscat.find(obj => obj.id === data.id_escala);
      let id_esc: number = 0;
      if (esc) {
        if (esc.id) {
          id_esc = esc.id;
        }
      }

      this.confirmationService.confirm({
        message: 'Estas Seguro que Deseas Guardar este Tabulado?',
        header: 'Confirmar',
        icon: 'pi pi-check-square',
        accept: () => {
          const paradasValores = this.obtenerParadasValores(); 
          this.isSaving = true;
          const data_enviar = this.buildPayloadGuardarNormal(data);

          this.tabuladorService.saveTabulador(data_enviar).subscribe({
            next: (resp) => {
              var respuesta = resp; // Mantenemos tu variable
              setTimeout(() => {
                this.cargarDatosTabla(data);
                this.ObtenerTablaPrincipal();
                this.message.add({ severity: 'success', summary: 'Éxito', detail: 'Tabulado guardado correctamente' });
                this.isSaving = false;
              }, 200);
            },
            error: (err) => {
               console.error(err);
               this.message.add({ severity: 'error', summary: 'Error', detail: 'No se pudo guardar el registro.' });
               this.isSaving = false;
            }
          });
        },
        reject: (type: any) => {
          switch (type) {
            case ConfirmEventType.REJECT:
              this.message.add({ key: 'msj', severity: 'warn', summary: 'Cancelado', detail: 'Operacion cancelada por usuario' });
              break;
            case ConfirmEventType.CANCEL:
              this.message.add({ key: 'msj', severity: 'warn', summary: 'Cancelado', detail: 'Operacion cancelada por usuario' });
              break;
          }
        }
      });
    }
  }

  cargarDatosTabla(data: any) {
    this.tablaRespuesta = this.tablaRespuesta.filter(element => element !== data); 
    this.tablaRespuesta = [...this.tablaRespuesta];
  }
  guardarInformacionTabulador() {
    if (this.tabuladorForm.get('tipo_tabulado')?.value === 1 && !this.rutaCalculada) {
        this.message.add({ severity: 'error', summary: 'Cálculo Requerido', detail: 'Debe presionar el botón "Calcular Ruta con Global Maps" antes de cotizar.' });
        return; 
    }

    const TipoConfiguracion = this.tabuladorForm.get('configuracion_Unidad')?.value;

    if (!TipoConfiguracion || TipoConfiguracion.length === 0) {
      this.message.add({ severity: 'danger', summary: 'Error', detail: 'Debe seleccionar al menos un usuario' });
      return;
    }
    let cadena: string = '';
    if (this.configuracionesSeleccionadas.length > 0) {
      this.configuracionesSeleccionadas.map((val) => {
        let configuracion: any = {
          clave_configuracionUnidad: val.toString()
        };
        configuracion.clave_configuracionUnidad = val.toString();
        cadena += val + ',';
        this.lstNombreConfiguracion.push(configuracion);
      });
    }
    this.confirmationService.confirm({
      message: 'Esta seguro que desea cotizar la Información ?',
      header: 'Confirmación para cotizar',
      icon: 'pi pi-info-circle',
      accept: () => {
        const paradasValores = this.obtenerParadasValores();
        let data_enviar = {
          id_tipo_tabulado: this.tabuladorForm.get('tipo_tabulado')?.value,
          unidadCosto: this.objImporteCaseta,
          id_tiporuta: this.tabuladorForm.get('Area')?.value,
          des_origen: this.getOrigenTexto(this.tabuladorForm),
          des_destino: this.getDestinoTexto(this.tabuladorForm),
          des_escala: this.getEscalaTexto(this.tabuladorForm),
          TxtOrigen: this.tabuladorForm.get('TxtOrigen')?.value || '',
          LatOrigen: this.toStr(this.tabuladorForm.get('LatOrigen')?.value ?? ''),
          LonOrigen: this.toStr(this.tabuladorForm.get('LonOrigen')?.value ?? ''),
          TxtDestino: this.tabuladorForm.get('TxtDestino')?.value || '',
          LatDestino: this.toStr(this.tabuladorForm.get('LatDestino')?.value ?? ''),
          LonDestino: this.toStr(this.tabuladorForm.get('LonDestino')?.value ?? ''),
          LatEscala: this.getEscalaCoordString(paradasValores, 'lat'),
          LonEscala: this.getEscalaCoordString(paradasValores, 'lng'),
          TxtParada1: paradasValores[0]?.texto || '',
          LatParada1: paradasValores[0]?.lat ?? null,
          LonParada1: paradasValores[0]?.lng ?? null,
          TxtParada2: paradasValores[1]?.texto || '',
          LatParada2: paradasValores[1]?.lat ?? null,
          LonParada2: paradasValores[1]?.lng ?? null,
          TxtParada3: paradasValores[2]?.texto || '',
          LatParada3: paradasValores[2]?.lat ?? null,
          LonParada3: paradasValores[2]?.lng ?? null,
          TxtParada4: paradasValores[3]?.texto || '',
          LatParada4: paradasValores[3]?.lat ?? null,
          LonParada4: paradasValores[3]?.lng ?? null,
          TxtParada5: paradasValores[4]?.texto || '',
          LatParada5: paradasValores[4]?.lat ?? null,
          LonParada5: paradasValores[4]?.lng ?? null,
          TxtParada6: paradasValores[5]?.texto || '',
          LatParada6: paradasValores[5]?.lat ?? null,
          LonParada6: paradasValores[5]?.lng ?? null,
          num_kilometros: this.tabuladorForm.get('kilometros')?.value,
          horas_cargaydescarga: this.tabuladorForm.get('hrs_carga_descarga')?.value,
          num_choferes: this.tabuladorForm.get('num_choferes')?.value,
          num_auxiliares: this.tabuladorForm.get('num_auxiliares')?.value,
          num_porcentajeutd: 0, 
          id_tipo_cliente: this.tabuladorForm.get('tipo_cliente')?.value,
          imp_terceros: this.TipoClienteSeleccionado == 2 ? this.tabuladorForm.get('comision_cliente')?.value : 0,
          imp_peajeindividual_extr: this.tabuladorForm.controls['imp_peajeindividual_extr'].disabled === true ? 0 : this.tabuladorForm.get('imp_peajeindividual_extr')?.value,
          imp_porcentajecancelado_extr: this.tabuladorForm.controls['imp_porcentajecancelado_extr'].disabled === true ? 0 : this.tabuladorForm.get('imp_porcentajecancelado_extr')?.value,
          imp_descargaCompleta_extr: this.tabuladorForm.controls['imp_descargaCompleta_extr'].disabled === true ? 0 : this.tabuladorForm.get('imp_descargaCompleta_extr')?.value,
          num_Personas_extr: this.tabuladorForm.controls['num_Personas_extr'].disabled === true ? 0 : this.tabuladorForm.get('num_Personas_extr')?.value,
          imp_Persona_extr: this.tabuladorForm.controls['imp_Persona_extr'].disabled === true ? 0 : this.tabuladorForm.get('imp_Persona_extr')?.value,
          imp_Subcontrato_extr: this.tabuladorForm.controls['imp_Subcontrato_extr'].disabled === true ? 0 : this.tabuladorForm.get('imp_Subcontrato_extr')?.value,
          horas_esperasalida: this.tabuladorForm.get('hrs_espera_salida')?.value,
          id_modo_ruta: this.tabuladorForm.get('id_modo_ruta')?.value,
          id_ciudad: this.tabuladorForm.get('centro_costos')?.value,
          clv_truck: this.tabuladorForm.get('es_truck')?.value,
          num_stop: this.tabuladorForm.get('num_stop')?.value,
          clv_maniobras: this.tabuladorForm.get('maniobras')?.value,
          id_perfil_ruta: this.tabuladorForm.get('perfilRuta')?.value,
          id_cte_prospecto: this.IdClienteGlobal,
          num_horas_pernocta: this.tabuladorForm.get('hrs_pernocta')?.value,
          num_dias_frecuencia: this.tabuladorForm.get('num_dias_frecuencia')?.value,
        };
        this.tabuladorService.getTabulador(data_enviar).subscribe((resp) => {
          this.tablaRespuesta = resp;
          this.uniqueConfigurations = this.getUniqueConfigurations(this.tablaRespuesta);
          
          this.cols = [
            { field: 'id_corrida', header: 'No. Tabulado' },
            { field: 'configuracion', header: 'Conf. Unidad' },
            { field: 'origen', header: 'Origen' },
            { field: 'destino', header: 'Destino' },
            { field: 'escala', header: 'Escala' },
            { field: 'num_dias', header: 'Numero de Dias' },
            { field: 'costo', header: 'Costo' },
            { field: 'num_porcentajeutd', header: 'Porcentaje UTD' },
            { field: 'imp_preciodeventa', header: 'Precio de Venta' },
            { field: 'imp_utilidad', header: 'Utilidad' },
            { field: 'imp_utilidadmensual', header: 'Utilidad Mensual' },
            { field: 'imp_sueldochofer', header: 'Sueldo Chofer' },
            { field: 'imp_sueldoaux', header: 'Sueldo Auxiliar' },
            { field: 'imp_combustible', header: 'Gasto Combustible' },
            { field: 'imp_comisioncombustible', header: 'Gasto Comision Combustible' },
            { field: 'imp_cel_gps', header: 'Gasto Celular GPS' },
            { field: 'imp_imss', header: 'IMSS' },
            { field: 'imp_hospedaje', header: 'Gasto Hospedaje' },
            { field: 'imp_viaticos', header: 'Gasto Viaticos' }
          ];

          setTimeout(() => {
            this.tabuladorForm.reset();
            this.tabuladorForm.controls['imp_porcentajecancelado_extr'].setValue(40);
            this.tabuladorForm.controls['porcentaje_UTD'].setValue(35);
            this.tabuladorForm.controls['hrs_carga_descarga'].setValue(1);
            this.tabuladorForm.controls['hrs_traslado_carga'].setValue(1);
            this.tabuladorForm.controls['hrs_espera_salida'].setValue(1);
            this.tabuladorForm.controls['hrs_retorno_base'].setValue(1);
            this.tabuladorForm.controls['hrs_pernocta'].setValue(1);
            this.configuracionesSeleccionadas = [];
            this.dspTablaRegreso = true;
            this.TipoClienteSeleccionado = 0;
            this.resetParadas();
          }, 400);
        })
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            this.message.add({ key: 'msj', severity: 'warn', summary: 'Cancelado', detail: 'Operacion cancelada por usuario' });
            break;
          case ConfirmEventType.CANCEL:
            this.message.add({ key: 'msj', severity: 'warn', summary: 'Cancelado', detail: 'Operacion cancelada por usuario' });
            break;
        }
      }
    });
  }
  getUniqueConfigurations(data: any[]): string[] {
    const configurations = data.map(item => item.configuracion);
    return [...new Set(configurations)];
  }

  Individual() {
    const form = this.getActiveForm();
    if (form.controls['imp_peajeindividual_extr'].disabled === true) {
      form.controls['imp_peajeindividual_extr'].enable();
    } else {
      form.controls['imp_peajeindividual_extr'].disable();
    }
  }
  Cancelado() {
    const form = this.getActiveForm();
    if (form.controls['imp_porcentajecancelado_extr'].disabled === true) {
      form.controls['imp_porcentajecancelado_extr'].enable();
    } else {
      form.controls['imp_porcentajecancelado_extr'].disable();
    }
  }
  DescargaCompleta() {
    const form = this.getActiveForm();
    if (form.controls['imp_descargaCompleta_extr'].disabled === true) {
      form.controls['imp_descargaCompleta_extr'].enable();
    } else {
      form.controls['imp_descargaCompleta_extr'].disable();
    }
  }
  PersonaHappy() {
    const form = this.getActiveForm();
    if (form.controls['num_Personas_extr'].disabled === true) {
      form.controls['num_Personas_extr'].enable();
    } else {
      form.controls['num_Personas_extr'].disable();
    }

    if (form.controls['imp_Persona_extr'].disabled === true) {
      form.controls['imp_Persona_extr'].enable();
    } else {
      form.controls['imp_Persona_extr'].disable();
    }
  }
  subcontratado() {
    const form = this.getActiveForm();
    if (form.controls['imp_Subcontrato_extr'].disabled === true) {
      form.controls['imp_Subcontrato_extr'].enable();
    } else {
      form.controls['imp_Subcontrato_extr'].disable();
    }
  }
  clearLocalStorageData() {
    localStorage.removeItem('DatosClientesProspecto');
  }
  Regresar() {
    this.router.navigateByUrl('/clientes-prospecto');
    this.clearLocalStorageData();
  }
  
createConfiguracionFormGroup(configuracion: any): FormGroup {
    let porcentajeDefault = 35;
    if (configuracion.id === 10) {
      porcentajeDefault = 25;
    }

    return this.fb.group({
      id: [configuracion.id], 
      nombre: [configuracion.nombre, ''],
      importeCasetaConfiguracion: [configuracion.importe, Validators.required],
      porcentajeUtilidadConfiguracion: [porcentajeDefault, [Validators.required, Validators.min(0)]]
    });
  }


  addImporteForm(data: FormGroup, index: number) {
    const idConf = data.get('id')?.value;
    const monto = data.get('importeCasetaConfiguracion')?.value;
    const porcentaje = data.get('porcentajeUtilidadConfiguracion')?.value;

    const existeIndex = this.objImporteCaseta.findIndex(x => x.id_configuracion === idConf);
    
    if (existeIndex !== -1) {
        this.objImporteCaseta[existeIndex].importeCasetaConfiguracion = monto;
        this.objImporteCaseta[existeIndex].porcentajeUtilidadConfiguracion = porcentaje;
    } else {

        if (this.dspEditarTAbulado) {
            this.objImporteCaseta = []; 
        }
        this.objImporteCaseta.push({
            id_configuracion: idConf,
            importeCasetaConfiguracion: monto,
            porcentajeUtilidadConfiguracion: porcentaje
        });
    }
    if (this.dspEditarTAbulado) {
        this.importesForm = [];
    } else {
        this.importesForms.splice(index, 1); 
    }

    this.message.add({ severity: 'success', summary: 'Importe Agregado', detail: 'Importe y Utilidad asignados correctamente' });
  }

  eliminarImporteGuardado(index: number) {
      this.objImporteCaseta.splice(index, 1);
      
      if (this.dspEditarTAbulado) {
          this.configuracionSeleccionada = 0;
          this.EditarTabuladoForm.controls['configuracion_Unidad'].setValue(null);
          this.importesForm = [];
      } else {
          this.Config(); 
      }
      
      this.message.add({ severity: 'info', summary: 'Removido', detail: 'Configuración removida de la lista' });
  }

  Config() {
    const seleccionadas = this.configuracionesSeleccionadas || [];
    this.objImporteCaseta = this.objImporteCaseta.filter(guardado => 
        seleccionadas.includes(guardado.id_configuracion)
    );

    this.importesForms = seleccionadas
        .filter(confId => !this.objImporteCaseta.some(g => g.id_configuracion === confId))
        .map(configuracion => {
            const unidad = this.cat_ConfiguracionUnidades.find(c => c.idx_respaldo_confunidad === configuracion);
            return this.createConfiguracionFormGroup({ id: configuracion, nombre: unidad?.nombre });
        });
  }

  Configi() {
    const configuracion = this.configuracionSeleccionada;
    if (!configuracion) {
        this.importesForm = [];
        return;
    }

    const configuracionUnidad = this.cat_ConfiguracionUnidades.find(c => c.idx_respaldo_confunidad === configuracion);
    const yaGuardada = this.objImporteCaseta.some(g => g.id_configuracion === configuracion);

    if (!yaGuardada) {
        let peajeOriginal = null;
        if (this.datoseditartabulador && this.datoseditartabulador.length > 0 && this.datoseditartabulador[0].id_config_unidad === configuracion) {
            peajeOriginal = this.datoseditartabulador[0].imp_peaje;
        }

        this.importesForm = [this.createConfiguracionFormGroup({ 
            id: configuracion, 
            nombre: configuracionUnidad?.nombre,
            importe: peajeOriginal
        })];
    } else {
        this.importesForm = [];
    }
  }
  
  handleChange(event: any) {
  }

  applyFilterGlobal($event: any, stringVal: any) {
    this.dt.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }

  cancelarVentanaEditarModal(){
    this.dspEditarTAbulado=false;
    this.EditarTabuladoForm.reset();
    this.configuracionesSeleccionadas=[];
    this.objImporteCaseta=[];
    this.dspTabulador = false;
    this.dspTabuladorDiario = false;
    this.importesForms = [];
    this.tablaRespuesta = [...this.tablaVacia];
    this.uniqueConfigurations = [...this.tablaVacia];
    this.dspTablaRegreso = false;
    this.idruta = null; 
    this.TablaRespuestaEditar = [...this.tablaVacia];
    this.loading = false;
    this.TipoClienteSeleccionado = 0;
    this.configuracionSeleccionada = 0;
    this.datoseditartabulador = [];
    this.importeSeleccionado = 0;
    this.googleOrigenSearch = '';
    this.googleDestinoSearch = '';
    this.googleEscalaSearch = '';
    this.rutaCalculada = false;
    this.EditarTabuladoForm.get('num_dias_frecuencia')?.setValue(0);
    this.resetParadas();
    this.EditarTabuladoForm.get('tipo_tabulado')?.setValue(1, { emitEvent: false });
    this.onTipoTabuladoChange({ value: 1 }, this.EditarTabuladoForm);
  }

 generarDiasDelMes() {
    const hoy = new Date();
    const anio = hoy.getFullYear();
    const mes = hoy.getMonth();
    
    const diasEnMes = new Date(anio, mes + 1, 0).getDate();

    this.opcionesDiasFrecuencia = [];
    for (let i = 1; i <= diasEnMes; i++) {
      this.opcionesDiasFrecuencia.push({ label: i.toString(), value: i });
    }
  }

onPerfilRutaChangeDropdown(event: any): void {
  const valor = event.value;
  const perfil = this.opcionesPerfilRuta.find(p => p.value === valor);
  this.importeSeleccionado = perfil ? perfil.importe : 0;
}

  get paradas(): FormArray {
    return this.getParadasFormArray();
  }

  private crearParadaGroup(): FormGroup {
    return new FormGroup({
      texto: new FormControl('', []),
      lat: new FormControl(null, []),
      lng: new FormControl(null, []),
      addr: new FormControl(null, [])
    });
  }

  ensureParadasIniciales(form?: FormGroup): void {
    const paradas = this.getParadasFormArray(form);
    if (paradas.length === 0) {
      this.agregarParada(form);
    }
  }

  agregarParada(form?: FormGroup): void {
    const paradas = this.getParadasFormArray(form);
    if (paradas.length >= this.maxParadas) {
      this.message.add({ severity: 'warn', summary: 'Límite alcanzado', detail: 'Solo se permiten hasta 6 paradas.' });
      return;
    }
    paradas.push(this.crearParadaGroup());
    this.syncEscalaControl(form);
  }

  eliminarParada(index: number, form?: FormGroup): void {
    const paradas = this.getParadasFormArray(form);
    if (paradas.length > 0) {
      paradas.removeAt(index);
    }
    this.syncEscalaControl(form);
  }

  private syncEscalaControl(form?: FormGroup): void {
    const targetForm = form ?? this.getActiveForm();
    const paradas = this.getParadasFormArray(targetForm);
    const textos = paradas.controls
      .map(ctrl => {
        const t = (ctrl.get('texto')?.value || '').toString().trim();
        if (!t) {
          ctrl.patchValue({ lat: 0, lng: 0 }, { emitEvent: false });
        }
        return t;
      })
      .filter(t => !!t);
    targetForm.patchValue({ escala: textos.join(' | ') });
  }

  private obtenerParadasValores(form?: FormGroup): { texto: string; lat: number | null; lng: number | null }[] {
    const paradas = this.getParadasFormArray(form);
    const valores = paradas.controls.map(ctrl => ({
      texto: ctrl.get('texto')?.value || '',
      lat: ctrl.get('lat')?.value ?? 0,
      lng: ctrl.get('lng')?.value ?? 0,
    }));

    while (valores.length < this.maxParadas) {
      valores.push({ texto: '', lat: 0, lng: 0 });
    }
    return valores.slice(0, this.maxParadas);
  }

  private resetParadas(form?: FormGroup): void {
    const paradas = this.getParadasFormArray(form);
    while (paradas.length > 0) {
      paradas.removeAt(0);
    }
    this.agregarParada(form);
  }

buscarDireccionGoogle(tipo: 'origen' | 'destino' | 'escala' | 'parada', index?: number) {
  const form = this.getActiveForm();
  let address = '';
  
  if (tipo === 'origen') {
    address = (this.googleOrigenSearch || '').trim();
  } else if (tipo === 'destino') {
    address = (this.googleDestinoSearch || '').trim();
  } else {
    const idx = index ?? 0;
    const paradas = this.getParadasFormArray(form);
    const parada = paradas.at(idx) as FormGroup;
    address = (parada?.get('texto')?.value || '').toString().trim();
  }
  if (!address) return;

  this.googleGeocodeLoading = true;

  this.globalMapsService.geocodeGoogle(address).subscribe({
    next: (resp) => {
      this.googleGeocodeLoading = false;

      const r0 = resp?.results?.[0];
      if (!r0) return;

      const components = r0.address_components || [];
      const primerLongName = components?.[0]?.long_name || '';
      const address = r0.formatted_address || [];

      const loc = r0?.geometry?.location;
      const lat = loc?.lat ?? null;
      const lng = loc?.lng ?? null;

      if (tipo === 'origen') this.googleOrigenSearch = primerLongName;
      if (tipo === 'destino') this.googleDestinoSearch = primerLongName;
      if (tipo === 'escala' || tipo === 'parada') this.googleEscalaSearch = primerLongName;

      const patch: any = {};
      if (tipo === 'origen') {
        patch.origenAddr = address
        patch.google_origen_address = primerLongName;
        patch.google_origen_lat = lat;
        patch.google_origen_lng = lng;
        patch.google_origen_address_components = components;
        patch.TxtOrigen = primerLongName;
        patch.LatOrigen = lat;
        patch.LonOrigen = lng;
      }
      if (tipo === 'destino') {
        patch.destinoAddr = address
        patch.google_destino_address = primerLongName;
        patch.google_destino_lat = lat;
        patch.google_destino_lng = lng;
        patch.google_destino_address_components = components;
        patch.TxtDestino = primerLongName;
        patch.LatDestino = lat;
        patch.LonDestino = lng;
      }
      if (tipo === 'escala' || tipo === 'parada') {
        const idx = index ?? 0;
        const paradas = this.getParadasFormArray(form);
        const paradaCtrl = paradas.at(idx) as FormGroup;
        paradaCtrl?.patchValue({
          texto: primerLongName,
          lat,
          lng,
          addr:address,
        });
        patch.google_escala_address = primerLongName;
        patch.google_escala_lat = lat;
        patch.google_escala_lng = lng;
        patch.google_escala_address_components = components;
        this.syncEscalaControl(form);
      }

      form.patchValue(patch);
    },
    error: () => {
      this.googleGeocodeLoading = false;
    }
  });
}

public valNotNullAddress(txt:string,index?: number):string
{
  const form = this.getActiveForm();
  if(index!=null){
    const idx = index ?? 0;
    const parada = this.getParadasFormArray(form).at(idx) as FormGroup;
    return (parada?.get('addr')?.value || '').toString().trim();
  }
  else   
    return form.get(txt)?.value;
}

private aplicarCoincidenciaMunicipio(tipo: 'origen' | 'destino' | 'escala' | 'parada', texto: string) {
  if (tipo === 'parada') return;
  const val = (texto || '').trim().toLowerCase();
  if (!val) return;
  const match = (this.municipioscat || []).find((m: any) =>
    (m?.municipio || '').toLowerCase().includes(val)
  );
  if (!match?.id) return;

  const form = this.getActiveForm();
  if (tipo === 'origen') form.patchValue({ origen: match.id });
  if (tipo === 'destino') form.patchValue({ destino: match.id });
  if (tipo === 'escala') form.patchValue({ escala: match.id }); 
}

private getMunicipioNombreById(id: any): string {
  const match = (this.municipioscat || []).find((m: any) => m?.id === id);
  return (match?.municipio || '').toString().trim();
}

private getMunicipioIdByNombre(nombre: string): number {
  const normalized = (nombre || '').toString().trim().toLowerCase();
  if (!normalized) return 0;
  const match = (this.municipioscat || []).find((m: any) =>
    (m?.municipio || '').toString().trim().toLowerCase() === normalized
  );
  return match?.id ?? 0;
}

private getOrigenTexto(form: FormGroup): string {
  const txt = (form.get('TxtOrigen')?.value || form.get('google_origen_address')?.value || '').toString().trim();
  if (txt) return txt;
  return this.getMunicipioNombreById(form.get('origen')?.value);
}

private getDestinoTexto(form: FormGroup): string {
  const txt = (form.get('TxtDestino')?.value || form.get('google_destino_address')?.value || '').toString().trim();
  if (txt) return txt;
  return this.getMunicipioNombreById(form.get('destino')?.value);
}

private getEscalaTexto(form: FormGroup): string {
  const escala = form.get('escala')?.value;
  if (typeof escala === 'string') return escala.toString().trim();
  if (typeof escala === 'number') return this.getMunicipioNombreById(escala);
  return '';
}

private toStr(value: any): string {
  if (value === null || value === undefined) return '';
  return String(value);
}

private getEscalaCoordString(
  paradasValores: { texto: string; lat: number | null; lng: number | null }[],
  key: 'lat' | 'lng'
): string {
  return paradasValores
    .filter(parada => (parada.texto || '').toString().trim() !== '')
    .map(parada => this.toStr((parada as any)[key]))
    .join(' | ');
}

  getNombreConfiguracion(id: number): string {
      const unidad = this.cat_ConfiguracionUnidades.find(c => c.idx_respaldo_confunidad === id);
      return unidad?.nombre ?? 'Desconocido';
  }

  EliminarTabulado(data: any) {
    this.confirmationService.confirm({
        message: `¿Estás seguro que deseas eliminar el tabulado #${data.id_corrida}? Esta acción no se puede deshacer.`,
        header: 'Confirmar Eliminación',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Sí, eliminar',
        rejectLabel: 'No',
        acceptButtonStyleClass: 'p-button-danger',
        accept: () => {
            this.loading = true;

            const payload = {
                idx: data.idx,
                id_cte_prospecto: this.IdClienteGlobal,
                cod_usuario: this.usuario.cod
            };

            this.tabuladorService.EliminarTabulador(payload).subscribe({
                next: (resp) => {
                    this.message.add({ key: 'msj', severity: 'success', summary: 'Eliminado', detail: 'Registro borrado con éxito.' });
                    this.ObtenerTablaPrincipal(); 
                },
                error: (err) => {
                    this.loading = false;
                    this.message.add({ key: 'msj', severity: 'error', summary: 'Error', detail: 'No se pudo eliminar.' });
                }
            });
        }
    });
}

  onExcelUpload(event: any) {
    const file = event.target.files[0];
    if (!file) return;

    this.loadingMasiva = true;

    this.tabuladorService.uploadExcelMasivo(file, this.IdClienteGlobal).subscribe({
      next: (response: any) => {
        this.loadingMasiva = false;
        
        if (response.status === true && response.buildCoordinates) {
            this.procesarRespuestaExitosa(response.buildCoordinates, response.failData);
        } else {
            this.message.add({ severity: 'warn', summary: 'Atención', detail: response.message || 'El archivo no generó registros.' });
        }
        event.target.value = ''; 
      },
      error: (err: any) => {
        this.loadingMasiva = false;
        event.target.value = ''; 
        this.procesarErrorValidacion(err);
      }
    });
  }


  procesarRespuestaExitosa(buildCoordinates: any[], failData: any[]) {
    let datosTabla: any[] = [];


    if (buildCoordinates && buildCoordinates.length > 0) {
        const validos = buildCoordinates.map(item => ({
            ...item,
            tiene_error: false,
            mensaje_error: '',
            configuracion: item.configuracion || 'S/N' 
        }));
        datosTabla = [...datosTabla, ...validos];
    }

    if (failData && failData.length > 0) {
        const fallidos = failData.map(item => {
            let errorDetallado = 'Error al procesar registro';


            if (item.validation_errors && item.validation_errors.length > 0) {

                let columnasAfectadas: string[] = [];
                item.validation_errors.forEach((valError: any) => {
                    if (valError.columns && Array.isArray(valError.columns)) {
                        columnasAfectadas = [...columnasAfectadas, ...valError.columns];
                    }
                });

  
                const msjBase = item.message || 'Parámetros inválidos';
                if (columnasAfectadas.length > 0) {
                     errorDetallado = `${msjBase}. Revisar: ${columnasAfectadas.join(', ')}`;
                } else {
                     errorDetallado = msjBase;
                }
            } else if (item.message) {
   
                 errorDetallado = item.message;
            } else if (item.mensaje_error) {
                 errorDetallado = item.mensaje_error;
            }

            return {
                ...item,
                tiene_error: true,
                mensaje_error: errorDetallado, 
                configuracion: item.configuracion || 'ERROR'
            };
        });
        datosTabla = [...datosTabla, ...fallidos];
    }

    if (datosTabla.length === 0) {
         this.message.add({ severity: 'warn', summary: 'Sin datos', detail: 'No hay registros para mostrar.' });
         return;
    }

    this.tablaRespuesta = datosTabla;
    this.uniqueConfigurations = this.getUniqueConfigurations(this.tablaRespuesta);
    
    this.dspTabulador = true;      
    this.dspTablaRegreso = true;   
    this.isListView = false;       
    this.actualizarLabelTexto();

    const errores = failData ? failData.length : 0;
    const exitosos = datosTabla.length - errores;

    if (errores > 0) {
        this.message.add({ severity: 'info', summary: 'Carga Completa', detail: `Se cargaron ${exitosos} correctos y ${errores} con errores.` });
    } else {
        this.message.add({ severity: 'success', summary: 'Carga Exitosa', detail: `Se cargaron ${exitosos} registros correctamente.` });
    }
  }

  procesarErrorValidacion(err: any) {
    const errorBody = err.error || err; 

    if (errorBody && errorBody.validation_errors && errorBody.validation_errors.length > 0) {
        
        let columnasAfectadas: string[] = [];
        
        errorBody.validation_errors.forEach((item: any) => {
            if (item.columns && Array.isArray(item.columns)) {
                columnasAfectadas = [...columnasAfectadas, ...item.columns];
            }
        });

        const columnasTexto = columnasAfectadas.join(', ');
        const titulo = 'Archivo no procesado';
        const detalle = `${errorBody.message || 'Error'} en columna: ${columnasTexto}`;

        this.message.add({ 
            severity: 'error', 
            summary: titulo, 
            detail: detalle, 
            life: 6000 
        });

    } 
    else if (errorBody && errorBody.message) {
        this.message.add({ 
            severity: 'error', 
            summary: 'Archivo no procesado', 
            detail: errorBody.message 
        });
    } 
    else {
        this.message.add({ 
            severity: 'error', 
            summary: 'Archivo no procesado', 
            detail: 'Ocurrió un error inesperado. Verifique el formato.' 
        });
    }
  }


  GuardarTodoTabulados(): void {
    const rows: any[] = (this.dspEditarTAbulado ? this.TablaRespuestaEditar : this.tablaRespuesta) || [];
    if (!rows || rows.length === 0) {
      this.message.add({ severity: 'warn', summary: 'Sin datos', detail: 'No hay tabulados para guardar.' });
      return;
    }

    const guardables = rows.filter(x => !x.tiene_error);

    if (guardables.length === 0) {
      this.confirmationService.confirm({
        message: 'No hay registros válidos para guardar. Revise las filas rojas.',
        header: 'Advertencia',
        icon: 'pi pi-times-circle',
        acceptLabel: 'Ok',
        rejectVisible: false,
        accept: () => {}
      });
      return;
    }

    this.confirmationService.confirm({
      message: `¿Deseas guardar TODOS los tabulados válidos?<br><b>Total:</b> ${guardables.length}`,
      header: 'Confirmar Guardado',
      icon: 'pi pi-check-square',
      accept: () => {
        this.isSaving = true;

        from(guardables).pipe(
          concatMap((row: any) =>
            this.guardarFilaMasivoSinConfirm(row).pipe(
              catchError((err) => {
                return from([{ __error: true, __row: row, __err: err }]);
              })
            )
          ),
          toArray(),
          finalize(() => (this.isSaving = false))
        ).subscribe((resultados: any[]) => {
           this.ObtenerTablaPrincipal();
           
           if (!this.dspEditarTAbulado) {
             guardables.forEach(g => this.cargarDatosTabla(g));
           } else {
             this.cancelarVentanaEditarModal();
           }

           const fallidos = resultados.filter(r => r?.__error);
           const ok = resultados.length - fallidos.length;

           this.message.add({
             severity: fallidos.length ? 'warn' : 'success',
             summary: 'Proceso Finalizado',
             detail: `Guardados: ${ok} | Fallidos: ${fallidos.length}`
           });
        });
      }
    });
  }


  private guardarFilaMasivoSinConfirm(row: any): Observable<any> {
    const payload = this.buildPayloadGuardarNormal(row);
    return this.tabuladorService.saveTabulador(payload);
  }

  private buildPayloadGuardarNormal(data: any): any {
    
    const configu = this.cat_ConfiguracionUnidades.find(obj => obj.nombre === data.configuracion);
    let configvalor = 0;
    if (configu?.clave_configuracionUnidad) {
      configvalor = configu.clave_configuracionUnidad;
    } else {
      configvalor = data.id_config_unidad || 0;
    }

    const estado = this.municipioscat.find(obj => obj.id === data.id_origen);
    const muni = this.municipioscat.find(obj => obj.id === data.id_destino);
    const esc = this.municipioscat.find(obj => obj.id === data.id_escala);

    const id_estado = estado?.id ?? (data.id_origen || 0);
    const id_muni = muni?.id ?? (data.id_destino || 0);
    const id_esc = esc?.id ?? (data.id_escala || 0);

    return {
      id_corrida: data.id_corrida || 0,
      id_cte_prospecto: this.IdClienteGlobal,
      id_config_unidad: configvalor,
      id_origen: id_estado,
      id_destino: id_muni,
      id_escala: id_esc,

      // Coordenadas Origen
      latOrigen_in: this.toStr(data.LatOrigen_in || data.latOrigen_in || data.LatOrigen || data.latOrigen || ''),
      lonOrigen_in: this.toStr(data.LonOrigen_in || data.lonOrigen_in || data.LonOrigen || data.lonOrigen || ''),
      
      // Coordenadas Destino
      latDestino_in: this.toStr(data.LatDestino_in || data.latDestino_in || data.LatDestino || data.latDestino || ''),
      lonDestino_in: this.toStr(data.LonDestino_in || data.lonDestino_in || data.LonDestino || data.lonDestino || ''),
      
      // Coordenadas Escala
      latEscala_in: this.toStr(data.LatEscala_in || data.latEscala_in || data.LatEscala || data.latEscala || ''),
      lonEscala_in: this.toStr(data.LonEscala_in || data.lonEscala_in || data.LonEscala || data.lonEscala || ''),

      des_origen_in: data.des_origen_in || data.des_origen || '',
      des_destino_in: data.des_destino_in || data.des_destino || '',
      des_escala_in: data.des_escala_in || data.des_escala || '',
      costo: data.costo,
      imp_preciodeventa: data.imp_preciodeventa,
      imp_utilidad: data.imp_utilidad,
      imp_utilidadmensual: data.imp_utilidadmensual,
      imp_sueldochofer: data.imp_sueldochofer,
      imp_sueldoaux: data.imp_sueldoaux,
      imp_combustible: data.imp_combustible,
      imp_comisioncombustible: data.imp_comisioncombustible,
      imp_cel_gps: data.imp_cel_gps,
      imp_imss: data.imp_imss,
      imp_hospedaje: data.imp_hospedaje,
      imp_viaticos: data.imp_viaticos,
      cod_usuario: this.usuario.cod,
      num_dias: data.num_dias,
      id_tiporuta: data.id_tiporuta,
      num_kilometros: data.num_kilometros,
      imp_peaje: data.imp_peaje,
      horas_cargaydescarga: data.horas_cargaydescarga,
      num_choferes: data.num_choferes,
      num_auxiliares: data.num_auxiliares,
      num_porcentajeutd: data.num_porcentajeutd,
      id_tipo_cliente: data.id_tipo_cliente,
      imp_terceros: data.imp_terceros,
      imp_peajeindividual_extr: data.imp_peajeindividual_extr,
      imp_porcentajecancelado_extr: data.imp_porcentajecancelado_extr,
      imp_descargaCompleta_extr: data.imp_descargaCompleta_extr,
      num_Personas_extr: data.num_Personas_extr,
      imp_Persona_extr: data.imp_Persona_extr,
      imp_Subcontrato_extr: data.imp_Subcontrato_extr,
      imp_comisionvendedor: data.imp_comisionvendedor,
      imp_comision_tercero: data.imp_comision_tercero,
      imp_mantenimiento: data.imp_mantenimiento,
      imp_operaciones: data.imp_operaciones,
      imp_seguridadpatrimonial: data.imp_seguridadpatrimonial,
      imp_depreciacion: data.imp_depreciacion,
      imp_urea: data.imp_urea,
      id_estatuspropuesta: 2,
      horas_trasladocarga: data.horas_trasladocarga,
      horas_esperasalida: data.horas_esperasalida,
      horas_retornobase: data.horas_retornobase,
      imp_propuestavalor: data.imp_propuestavalor,
      imp_permisocirculacion: data.imp_permisocirculacion,
      imp_combustible_casetas: data.imp_combustible_casetas,
      imp_serviciocorrectivo: data.imp_serviciocorrectivo,
      costo_urea_sin_iva_peaje: data.costo_urea_sin_iva_peaje,
      num_dias_ruta: data.num_dias_ruta,
      num_dias_dec: data.num_dias_dec, //NUEVO CAMPO
      imp_utilidad_con_urea_sin_iva_peaje: data.imp_utilidad_con_urea_sin_iva_peaje,
      num_porcentaje_margen: data.num_porcentaje_margen,
      imp_llantas: data.imp_llantas,
      id_modo_ruta: data.id_modo_ruta,
      id_perfil_ruta: data.id_perfil_ruta,
      imp_perfil_ruta: data.imp_perfil_ruta,
      hrs_descanso: data.hrs_descanso,
      id_tipo_tabulado: data.id_tipo_tabulado,
      num_horas_pernocta: data.num_horas_pernocta,
      num_horas_carga_combustible: data.num_horas_carga_combustible,
      imp_pdv_comision_terceros: data.imp_pdv_comision_terceros,
      num_dias_frecuencia: data.num_dias_frecuencia,
      imp_precio_de_frecuencia: data.imp_precio_de_frecuencia,
      
      num_stop_in: data.num_stop_in ?? data.num_stop ?? 0,
      id_ciudad_in: data.id_ciudad_in ?? data.id_ciudad ?? 0,
      clv_maniobras_in: data.clv_maniobras_in ?? data.clv_maniobras ?? 0,
      clv_truck_in: data.clv_truck_in ?? data.clv_truck ?? 0,
      imp_stop: data.imp_stop,
      imp_maniobras: data.imp_maniobras,
      imp_costo_kilometros: data.imp_costo_kilometros,
      sueldo_total_chofer: data.sueldo_total_chofer,
      horas_entreservicio: data.horas_entreservicio
    };
  }

  private buildPayloadGuardarEditar(data: any): any {
    const configu = this.cat_ConfiguracionUnidades.find(obj => obj.nombre === data.configuracion);
    let configvalor = 0;
    if (configu?.clave_configuracionUnidad) configvalor = configu.clave_configuracionUnidad;

    const estado = this.municipioscat.find(obj => obj.municipio === data.origen);
    const muni = this.municipioscat.find(obj => obj.municipio === data.destino);
    const esc = this.municipioscat.find(obj => obj.municipio === data.escala);

    const id_estado = estado?.id ?? 0;
    const id_muni = muni?.id ?? 0;
    const id_esc = esc?.id ?? 0;

    return {
    };
  }


  validarYAbrirOfrecerRuta(data: any) {
    this.data_tabulador = data;

    if (data.idx_tab_tdo && data.idx_tab_tdo > 0) {
      this.message.add({
        key: 'msj',
        severity: 'error',
        summary: 'Tabulador ya asignado',
        detail: `Este registro ya cuenta con el tabulador #${data.idx_tab_tdo}. Favor de revisar en el sistema de nómina.`
      });
      return; 
    }

    this.clienteEnlazado = false;
    this.rutaGeneradaExito = false;
    this.claveRutaGeneradaId = 0;
    this.claveRutaGeneradaTexto = '';
    this.rutaForm.reset();
    
    const ruta = [
    data.config_unidad,
    data.des_origen,
    data.des_destino
    ]
    .filter(Boolean)
    .join('|');

    this.rutaForm.patchValue({
      destinoRutaManual: ruta 
    });

    this.tabForm.reset();
    const totalPersonal = data.num_choferes + data.num_auxiliares;
    const toDecimal2 = (value: number) => Number((value || 0).toFixed(2));
    const dividirSeguro = (importe: number, divisor: number) => divisor === 0 ? 0 : toDecimal2(importe / divisor);
    // Drivers
    const imp_sueldo_total_driver = data.num_choferes === 0
    ? 0
    : dividirSeguro(data.sueldo_total_chofer, data.num_choferes);

    const imp_alimento_total_driver =
    data.num_choferes === 0 || data.imp_viaticos === 0 || totalPersonal === 0
    ? 0
    : dividirSeguro(data.imp_viaticos, totalPersonal);

    // Auxiliares
    const imp_sueldo_total_aux =
      data.num_auxiliares === 0
    ? 0
    : dividirSeguro(data.imp_sueldoaux, data.num_auxiliares);

    const imp_alimento_total_aux =
    data.num_auxiliares === 0 || data.imp_viaticos === 0 || totalPersonal === 0
    ? 0
    : dividirSeguro(data.imp_viaticos, totalPersonal);
    const diasEstancia = Math.round(data.num_dias - 1);
    const importeBase = totalPersonal === 0 || data.imp_hospedaje === 0 || diasEstancia === 0? 0 : Number(((data.imp_hospedaje / totalPersonal) / diasEstancia).toFixed(2));
    const imp_estancia_chofer = data.num_choferes === 0 ? 0 : importeBase;
    const imp_estancia_aux = data.num_auxiliares === 0 ? 0 : importeBase;

     this.tabForm.patchValue({
      sueldo_total_chofer: imp_sueldo_total_driver,
      imp_sueldoaux: imp_sueldo_total_aux, 
      imp_viaticos_chofer:imp_alimento_total_driver, 
      imp_viaticos_aux:imp_alimento_total_aux, 
      imp_hospedaje_chofer:imp_estancia_chofer,
      imp_hospedaje_aux:imp_estancia_aux
    });

    if (data.id_cliente_tdo && data.id_cliente_tdo > 0) {
        this.clienteEnlazado = true; 
        this.dspOfrecerRuta = true;
        if(data.id_ruta_tdo && data.id_ruta_tdo > 0){
          this.claveRutaGeneradaId = data.id_ruta_tdo;
          this.claveRutaGeneradaTexto =  `RT-${ this.claveRutaGeneradaId.toString().padStart(4, '0')}`;
          this.rutaGeneradaExito=true;
        }
    } else {
        this.ejecutarAltaCliente();
    }
  }

  ejecutarAltaCliente() {
    this.loading = true;
    this.tabuladorService.buscarORegistrarCliente(this.data_tabulador.id_cte_prospecto).subscribe({
      next: (resp: any) => {
        this.loading = false;

        if (resp.clv_estatus > 0) {
          this.clienteEnlazado = true;
          this.data_tabulador.id_cliente_tdo = -1; 
          this.dspOfrecerRuta = true; 
          this.message.add({ severity: 'success', summary: 'Cliente Listo', detail: resp.messageDetails });
        } else {
          this.message.add({ severity: 'error', summary: 'Error', detail: 'Contacte al administrador del sitio.' });
        }
      },
      error: () => {
        this.loading = false;
        this.message.add({ severity: 'error', summary: 'Error', detail: 'Contacte al administrador del sitio.' });
      }
    });
  }

  generarRutaOperativa() {
    if (this.rutaForm.get('nombreRutaManual')?.invalid) {
      this.message.add({ severity: 'warn', summary: 'Dato Requerido', detail: 'Debe ingresar el Folio de Proyecto (Ej. PP-01).' });
      return;
    }

    this.loading = true;
    const payload = {
        id_cliente_prospecto: this.data_tabulador.id_cte_prospecto,
        idx: this.data_tabulador.idx,
        num_folio_proyecto: this.rutaForm.get('nombreRutaManual')?.value,
        cod_usuario: this.usuario.cod || '0000'
    };

    this.tabuladorService.generarRutaNormal(payload).subscribe({
      next: (resp: any) => {
        this.loading = false;
        if (resp.clv_estatus === 1 && resp.clave_ruta) {
          this.rutaGeneradaExito = true;
          this.claveRutaGeneradaId = resp.clave_ruta; 
          this.claveRutaGeneradaTexto = `RT-${resp.clave_ruta.toString().padStart(4, '0')}`;
          this.message.add({ severity: 'success', summary: 'Ruta Generada', detail: resp.messageDetails });
        } else {
          this.message.add({ severity: 'error', summary: 'Error', detail: resp.messageDetails });
        }
      },
      error: () => {
        this.loading = false;
        this.message.add({ severity: 'error', summary: 'Error', detail: 'No se pudo generar la ruta.' });
      }
    });
  }

  registrarTabuladorFinal() {
    this.loading = true;
    
    const payload = {
        idx: this.data_tabulador.idx,
        id_ruta: this.claveRutaGeneradaId 
    };

    this.tabuladorService.registrarTabuladorFinal(payload).subscribe({
      next: (resp: any) => {
        this.loading = false;
        if (resp.clv_estatus === 1) {
          this.message.add({ severity: 'success', summary: 'Proceso Terminado', detail: resp.messageDetails });
          this.dspOfrecerRuta = false; 
          this.ObtenerTablaPrincipal(); 
        } else {
          this.message.add({ severity: 'error', summary: 'Atención', detail: resp.messageDetails });
        }
      },
      error: () => {
        this.loading = false;
        this.message.add({ severity: 'error', summary: 'Error', detail: 'Contacte al administrador del sitio.' });
      }
    });
  }

  cancelarVentanaModal() {
    this.tabuladorForm.reset();

    const allControls = [
        'configuracion_Unidad', 'Area', 'kilometros', 'hrs_carga_descarga',
        'hrs_traslado_carga', 'hrs_espera_salida', 'hrs_retorno_base', 'num_choferes',
        'num_auxiliares', 'porcentaje_UTD', 'tipo_cliente', 'origen', 'destino',
        'escala', 'imp_peajeindividual_extr', 'imp_porcentajecancelado_extr',
        'imp_descargaCompleta_extr', 'num_Personas_extr', 'imp_Persona_extr',
        'imp_Subcontrato_extr', 'comision_cliente', 'centro_costos', 'es_truck',
        'num_stop', 'maniobras', 'id_modo_ruta', 'perfilRuta', 'hrs_pernocta'
    ];
    allControls.forEach(controlName => this.tabuladorForm.get(controlName)?.disable());
    this.tabuladorForm.get('tipo_tabulado')?.enable();

    this.configuracionesSeleccionadas=[];
    this.objImporteCaseta=[];
    this.dspTabulador = false;
    this.dspTabuladorDiario = false;
    this.importesForms = [];
    this.tablaRespuesta = [...this.tablaVacia];
    this.uniqueConfigurations = [...this.tablaVacia];
    this.dspTablaRegreso = false;
    this.idruta = null; 
    this.TipoClienteSeleccionado = 0;
    this.importeSeleccionado = 0;
    this.googleOrigenSearch = '';
    this.googleDestinoSearch = '';
    this.googleEscalaSearch = '';
    this.rutaCalculada = false;
    this.loading = false;
    this.resetParadas(this.tabuladorForm);
    this.tabuladorForm.get('tipo_tabulado')?.setValue(1, { emitEvent: false });
    this.onTipoTabuladoChange({ value: 1 }, this.tabuladorForm);
  }
  orderOptions = [
    { label: 'Ascendente', value: 'asc' },
    { label: 'Descendente', value: 'desc' }
];
}